/// <reference path="../typings/index.d.ts" />
namespace App {
  export class TopSniperFernando {
    private ajax: any = null
    private urlUpdateFiltro: string = null
    private topCartasMomento: ICartaTopSniper[] = [];
    private cartasPrecificadasMomento: ICartaTopSniper[] = [];
    private filtrosHibridosSelecionados: any[] = [];
    private filtrosTopMultirraridadeSelecionados: any[] = [];
    private analiseMercadoFernando: any = null;
    private keyStorageCartasArmazenadas: string = 'cartasArmazenadas';
    private keyStorageUltimaVezSalvoFiltroFull: string = 'ultimaVezSalvo';
    private keyStorageSnapshotFrequencia: string = 'topSniperFernandoSnapshotFrequenciaV1';
    private keyStorageHistoricoMercado: string = 'topSniperFernandoHistoricoMercadoV1';
    private keyStorageHistoricoFrequenciaCartas: string = 'topSniperFernandoHistoricoFrequenciaCartasV1';
    private keyStorageHistoricoCandidatosPadrao: string = 'topSniperFernandoHistoricoCandidatosPadraoV1';
    private keyStorageHistoricoCandidatosMulti: string = 'topSniperFernandoHistoricoCandidatosMultiV1';
    private keyStorageModoMercado: string = 'topSniperFernandoModoMercadoV1';
    private keyStorageInstanciaToken: string = 'topSniperFernandoInstanciaTokenV1';
    private keyStorageForcarPrecoFresco: string = 'topSniperFernandoForcarPrecoFrescoAte';
    private keyStorageUltimaProtecaoId: string = 'topSniperFernandoUltimaProtecaoId';
    private estrategia: string = 'fernando_hibrido_v1';
    // Sem esses limites uma extensao ou endpoint sem resposta deixa o ciclo pendurado.
    private timeoutRespostaExtensao: number = 60000;
    private timeoutRequisicaoInteligencia: number = 20000;
    private timeoutRequisicaoEstado: number = 45000;
    private timeoutRequisicaoTopFiltros: number = 60000;
    private opcoes: any = {};
    private urlsInteligencia: any = {};
    private estadoInteligencia: any = null;
    private lideranca: any = null;
    private farmSaude: any = null;
    private protecaoMercado: any = null;
    private controleMixFiltros: any = null;
    private historicoFrequenciaCartasMemoria: any = {};
    // Cache do historico de frequencia lido do storage. Sem ele, getHistoricoFrequenciaCarta
    // reparseia o JSON inteiro do localStorage uma vez por carta (estouro de memoria da aba).
    private historicoFrequenciaCartasStorage: any = null;
    private historicoCandidatosMultiStorage: any[] = null;
    private intervaloEmMinutosStorageTempoAtualizacaoFiltroFull: number = 120; // 2 horas em minutos
    private static excludesAssetId: any = [5740, 1605, 238384, 190871]
    private static excludesRareFlag: any = [76]
    private configuracoesHibrido: any = {
      alta: {
        soma_quantidade_mais: 41,
        cartas_unicas_com_aumento: 35,
        soma_muito_forte: 55,
        ciclos_altos_para_entrar: 2,
        janela_ciclos_entrada: 3
      },
      baixa: {
        soma_quantidade_mais: 30,
        cartas_unicas_com_aumento: 25,
        minutos_sem_alta_para_sair: 10
      },
      historico: {
        max_ciclos: 10
      }
    };

    private configuracoes: {
      filtros: {
        id_filtro_especial_piloto_a: number,
        id_filtro_especial_piloto_b: number,
        id_filtro_especial_piloto_c: number,
        id_filtro_especial_piloto_d: number,
        id_filtro_piloto_inicial_A: number,
        id_filtro_piloto_inicial_B: number,
        id_filtro_piloto_inicial_C: number,
        id_filtro_piloto_full_A: number,
        id_filtro_piloto_full_B: number,
        id_filtro_piloto_top_filtros_A: number,
        id_filtro_piloto_top_filtros_B: number,
      },
      piloto: {
        full: {
          lucro_unitario_minimo: number
          lucro_unitario_minimo_cartas_relacionadas: number // para aquelas cartass de mesma raridade que quero colocar junto ao filtro da carta principal
          total_cartas_relacionadas_incluir_no_filtro: number
        },
        inicial: {
          raridade_minima_piloto_inicial: number
          valor_caixa_maximo: number
          preco_compra_carta_acima_de: number
          lucro_unitario_minimo: number,
          lucro_unitario_minimo_cartas_relacionadas: number // para aquelas cartass de mesma raridade que quero colocar junto ao filtro da carta principal
          total_cartas_relacionadas_incluir_no_filtro: number
        },
        principal: {
          raridade_minima_piloto_principal: number,
          lucro_unitario_minimo: number
          lucro_unitario_minimo_cartas_relacionadas: number // para aquelas cartass de mesma raridade que quero colocar junto ao filtro da carta principal
          valor_caixa_maximo: number
          preco_compra_carta_acima_de: number
          desconsiderar_poucas_cartas_acima_de: number
          quantidade_considero_poucas_cartas: number
          quantidade_indicativa_que_a_carta_esta_caindo: number
          total_cartas_relacionadas_incluir_no_filtro: number
        }
      },
      minimo_lucro_total_carta: number,
      usar_filtro_qualidade: boolean,
    } = null

    constructor(urlUpdateFiltro: string, opcoes: any = null) {
      this.urlUpdateFiltro = urlUpdateFiltro
      this.opcoes = opcoes || {}
      this.urlsInteligencia = this.opcoes.urls || {}
      this.keyStorageForcarPrecoFresco = this.opcoes.keyStorageForcarPrecoFresco || this.keyStorageForcarPrecoFresco
      this.configuracoes = {
        filtros: {
          id_filtro_especial_piloto_a: 50105,
          id_filtro_especial_piloto_b: 50311,
          id_filtro_especial_piloto_c: 50557,
          id_filtro_especial_piloto_d: 53982,
          id_filtro_piloto_inicial_A: 54949,
          id_filtro_piloto_inicial_B: 0,
          id_filtro_piloto_inicial_C: 0,
          id_filtro_piloto_full_A: 60313,
          id_filtro_piloto_full_B: 60548,

          id_filtro_piloto_top_filtros_A: 57554,
          id_filtro_piloto_top_filtros_B: 59226
        },
        piloto: {
          full: {
            lucro_unitario_minimo: 30000,
            lucro_unitario_minimo_cartas_relacionadas: 15000, // para aquelas cartass de mesma raridade que quero colocar junto ao filtro da carta principal
            total_cartas_relacionadas_incluir_no_filtro: 1
          },
          inicial: {
            raridade_minima_piloto_inicial: 1, // raridade minima de filtro das cartas para edição dos filtros do piloto inicial
            valor_caixa_maximo: 10000, // lucro minimo que a carta tem que dá para passar no filtro
            preco_compra_carta_acima_de: 700, // filtrar apenas cartas que são compradas acima desse valor
            lucro_unitario_minimo: 1000, // a carta tem que dá no minimo esse lucro para passar no filtro
            lucro_unitario_minimo_cartas_relacionadas: 1000, // para aquelas cartass de mesma raridade que quero colocar junto ao filtro da carta principal
            total_cartas_relacionadas_incluir_no_filtro: 1
          },
          principal: {
            raridade_minima_piloto_principal: 1, // raridade minima das cartas para passar no filtro
            lucro_unitario_minimo: 30000, // a carta tem que dá no minimo esse lucro para passar no filtro
            valor_caixa_maximo: 150000, // cria filtros com o caixa limite informado.
            preco_compra_carta_acima_de: 10000, // filtrar apenas cartas que são compradas acima desse valor
            desconsiderar_poucas_cartas_acima_de: 500000, // desconsidear cartas que tem poucas unidades e são compradas acima desse valor
            quantidade_considero_poucas_cartas: 1, // quantidade de cartas que considero poucas
            quantidade_indicativa_que_a_carta_esta_caindo: 1, // quantidade de cartas que indica que a carta está caindo no momento
            lucro_unitario_minimo_cartas_relacionadas: 10000, // para aquelas cartass de mesma raridade que quero colocar junto ao filtro da carta principal
            total_cartas_relacionadas_incluir_no_filtro: 0
          }
        },

        minimo_lucro_total_carta: 100000, // lucro geral obtido com a carta para poder entrar no topCartas
        usar_filtro_qualidade: false
      };
    }

    public async validarRegrasUrlCarregada(urlAtual: string): Promise<string> {
      return null
    }

    public iniciarRecarregamento() {
      window.location.replace('https://futsniperweb.com.br/admin/top-sniper')
    }

    /**
   * Condição para as cartas certas que considero importantes está em minha análise
   * @param objTopCarta
   */
    public condicaoTopCartasImportantes(objTopCarta: ICartaTopSniper) {
      if (!objTopCarta) return;
      if (!this.ehCartaConsole(objTopCarta)) return;

      this.cartasPrecificadasMomento.push(objTopCarta)

      if (objTopCarta.lucro > this.configuracoes.minimo_lucro_total_carta && !TopSniperFernando.excludesAssetId.includes(parseInt(objTopCarta.asset_id as any)) && !TopSniperFernando.excludesRareFlag.includes(parseInt(objTopCarta.rareflag as any))) {
        this.topCartasMomento.push(objTopCarta)
      }
    }

    public async prepararTopCartas() {
      this.analiseMercadoFernando = this.analisarMercadoFernando();
      this.aplicarFrequenciaFernando(this.cartasPrecificadasMomento, this.analiseMercadoFernando.mapaQuantidadeMais);
      this.aplicarFrequenciaFernando(this.topCartasMomento, this.analiseMercadoFernando.mapaQuantidadeMais);
      if (this.configuracoes.usar_filtro_qualidade) {
        this.topCartasMomento = await Promise.all(this.topCartasMomento.slice(0, 120).map(async (item: ICartaTopSniper) => ({ ...item, player_info: await TopSniperUtil.filtrarPlayerInfoOrg(item.nome, item.resource_id, true) })));
      }
      this.topCartasMomento.sort((a: any, b: any) => b.lucro - a.lucro);
      await this.inicializarInteligenciaCentral();
      await this.registrarAlertaOuProtecaoSeNecessario();
      if (this.deveAguardarPrecoFrescoAntesDaAnalise()) {
        await this.tentarAtualizarPrecosFutggEmLoteSeNecessario();
      } else {
        this.tentarAtualizarPrecosFutggEmLoteSeNecessario().catch((): null => null);
      }
      TopSniperUtil.logTopSniper('TOP_CARTAS_NANDO', this.topCartasMomento);
      this.iniciandoAnaliseTopcartas();
      this.renderizarPainelObservadorFernando();
      this.registrarDecisaoInteligencia('padrao');
      this.iniciandoAnaliseTopFiltros();
    }

    public liberarMemoriaAposPreparacao(): void {
      this.cartasPrecificadasMomento = [];
      this.topCartasMomento = [];
      this.historicoFrequenciaCartasMemoria = {};
      this.historicoFrequenciaCartasStorage = null;
      this.historicoCandidatosMultiStorage = null;
    }

    private async inicializarInteligenciaCentral(): Promise<void> {
      if (!this.urlsInteligencia || !this.urlsInteligencia.estado) {
        return;
      }

      try {
        // Prazo maior que os demais: se /estado falhar, a instancia se assume observadora e o
        // ciclo inteiro deixa de salvar filtros. Uma lentidao momentanea do servidor nao pode
        // custar um ciclo de farm.
        const estado = await this.postJson(this.urlsInteligencia.estado, {
          id_user: 7,
          estrategia: this.estrategia,
          instancia_token: this.getInstanciaToken(),
          analise_mercado: this.getResumoAnaliseMercado(),
          filtros_gerenciados: this.getIdsFiltrosGerenciados()
        }, this.timeoutRequisicaoEstado);

        this.estadoInteligencia = estado || null;
        this.lideranca = estado && estado.lideranca ? estado.lideranca : null;
        this.farmSaude = estado && estado.farm_saude ? estado.farm_saude : null;
        this.protecaoMercado = estado && estado.protecao ? estado.protecao : null;
        this.controleMixFiltros = estado && estado.controle_slots ? estado.controle_slots : (estado && estado.controle_mix ? estado.controle_mix : null);
        this.sincronizarProtecaoLocal();
      } catch (e) {
        console.warn('TopSniperFernando inteligencia indisponivel', e);
      }
    }

    private getInstanciaToken(): string {
      let token = sessionStorage.getItem(this.keyStorageInstanciaToken);
      if (!token) {
        token = `${Date.now()}-${Math.floor(Math.random() * 1000000)}`;
        sessionStorage.setItem(this.keyStorageInstanciaToken, token);
      }

      return token;
    }

    private postJson(url: string, payload: any, timeout: number = null): Promise<any> {
      return new Promise((resolve: any, reject: any) => {
        if (!url) {
          resolve(null);
          return;
        }

        $.ajax({
          url: url,
          type: 'POST',
          contentType: 'application/json',
          data: JSON.stringify(payload || {}),
          timeout: timeout ? timeout : this.timeoutRequisicaoInteligencia,
          beforeSend: function (jqXHR: any): void {
            jqXHR.setRequestHeader('X-CSRF-TOKEN', $('meta[name=csrf-token]').attr("content"));
          },
          success: (dados: any): void => resolve(dados),
          error: (jqXHR: any, status: any, error: any): void => reject(error || status || jqXHR)
        });
      });
    }

    private getResumoAnaliseMercado(): any {
      const analise = this.analiseMercadoFernando || {};
      return {
        modo: analise.modo,
        modoAnterior: analise.modoAnterior,
        sinal: analise.sinal,
        motivo: analise.motivo,
        minutosSemAlta: analise.minutosSemAlta,
        soma_quantidade_mais: this.toNumber(analise.soma_quantidade_mais),
        cartas_unicas_com_aumento: this.toNumber(analise.cartas_unicas_com_aumento),
        cartas_novas_no_snapshot: this.toNumber(analise.cartas_novas_no_snapshot),
        total_cartas_snapshot: this.toNumber(analise.total_cartas_snapshot),
        fonte: analise.fonte,
        plataforma: 'Console'
      };
    }

    private getIdsFiltrosGerenciados(): number[] {
      return [
        this.configuracoes.filtros.id_filtro_especial_piloto_a,
        this.configuracoes.filtros.id_filtro_especial_piloto_b,
        this.configuracoes.filtros.id_filtro_especial_piloto_c,
        this.configuracoes.filtros.id_filtro_especial_piloto_d,
        this.configuracoes.filtros.id_filtro_piloto_top_filtros_A,
        this.configuracoes.filtros.id_filtro_piloto_top_filtros_B
      ];
    }

    private sincronizarProtecaoLocal(): void {
      if (!this.protecaoMercado) return;

      const protecaoAtiva = !!this.protecaoMercado.ativa || !!this.protecaoMercado.bloqueia_salvamento;
      if (!protecaoAtiva) return;

      const protecaoId = this.protecaoMercado.id ? this.protecaoMercado.id.toString() : '';
      const ultimaProtecaoId = localStorage.getItem(this.keyStorageUltimaProtecaoId);

      if (protecaoId && protecaoId !== ultimaProtecaoId) {
        localStorage.removeItem(this.opcoes.keyStorageCachePrecoFutbin || 'key_storage_cache_preco_futbin');
        this.setStorageValorSeguro(this.keyStorageUltimaProtecaoId, protecaoId);
      }

      if (this.ehLider()) {
        sessionStorage.setItem(this.keyStorageForcarPrecoFresco, (Date.now() + (2 * 60 * 1000)).toString());
      } else {
        sessionStorage.removeItem(this.keyStorageForcarPrecoFresco);
      }
    }

    private async registrarAlertaOuProtecaoSeNecessario(): Promise<void> {
      if (!this.urlsInteligencia || !this.urlsInteligencia.protecao || !this.ehLider()) {
        return;
      }

      if (this.protecaoBloqueiaSalvamento()) {
        return;
      }

      const analise = this.analiseMercadoFernando || {};
      const mercadoMovimentado = analise.modo === 'alta' || analise.sinal === 'alto';
      const saudeFernando = this.getClassificacaoSaudeFernando();
      const saudeBaixa = saudeFernando === 'muito_baixo' || saudeFernando === 'medio';
      const alertaVolume = this.toNumber(analise.soma_quantidade_mais) >= this.configuracoesHibrido.alta.soma_muito_forte
        || this.toNumber(analise.cartas_novas_no_snapshot) >= 8;

      if (!mercadoMovimentado || !saudeBaixa || !alertaVolume) {
        return;
      }

      try {
        const resposta = await this.postJson(this.urlsInteligencia.protecao, {
          id_user: 7,
          estrategia: this.estrategia,
          instancia_token: this.getInstanciaToken(),
          status: 'alerta',
          classificacao: 'alerta_volume_saude_baixa',
          motivo: 'Saude do Fernando baixa/media com mercado movimentado e volume fora do padrao.',
          analise_mercado: this.getResumoAnaliseMercado(),
          farm_saude: this.farmSaude
        });

        if (resposta && resposta.protecao) {
          this.protecaoMercado = resposta.protecao;
          this.sincronizarProtecaoLocal();
        }
      } catch (e) {
        console.warn('Falha ao registrar alerta/protecao TopSniperFernando', e);
      }
    }

    private registrarDecisaoInteligencia(tipo: string): void {
      if (!this.urlsInteligencia || !this.urlsInteligencia.decisao) {
        return;
      }

      const filtros = tipo === 'multi_raridade'
        ? (this.filtrosTopMultirraridadeSelecionados || [])
        : (this.filtrosHibridosSelecionados || []);
      const filtrosCompactos = filtros.map((filtro: any): any => this.compactarFiltroDecisao(filtro));
      const classificacao = this.getClassificacaoCiclo();

      this.postJson(this.urlsInteligencia.decisao, {
        id_user: 7,
        estrategia: this.estrategia,
        instancia_token: this.getInstanciaToken(),
        tipo_registro: tipo,
        classificacao: classificacao,
        pode_salvar: this.podeSalvarFiltrosAgora(),
        motivo: this.getMotivoCiclo(),
        lideranca: this.lideranca,
        analise_mercado: this.getResumoAnaliseMercado(),
        farm_saude: this.getFarmSaudeDecisaoCompacta(),
        protecao: this.protecaoMercado,
        filtros: filtrosCompactos
      }).catch((e: any) => console.warn('Falha ao registrar decisao TopSniperFernando', e));
    }

    private getFarmSaudeDecisaoCompacta(): any {
      const farm = this.farmSaude || {};
      const performance = farm.performance_filtros_60m || {};
      const filtrosPerformance: any = {};

      Object.keys(performance.filtros || {}).forEach((slotId: string): void => {
        const filtro = performance.filtros[slotId] || {};
        filtrosPerformance[slotId] = {
          slot_id: filtro.slot_id,
          slot_rank: filtro.slot_rank,
          slot_grupo: filtro.slot_grupo,
          status_ativo: filtro.status_ativo,
          slot_updated_at: filtro.slot_updated_at,
          filtro_assinatura_hash: filtro.filtro_assinatura_hash,
          assinatura_base_hash: filtro.assinatura_base_hash,
          assinatura_estavel_60m: filtro.assinatura_estavel_60m,
          assinatura_estabilidade_motivo: filtro.assinatura_estabilidade ? filtro.assinatura_estabilidade.motivo : null,
          nome: filtro.nome,
          cartas_encontradas: filtro.cartas_encontradas,
          cartas_compradas: filtro.cartas_compradas,
          lucro_previsto_sniper: filtro.lucro_previsto_sniper
        };
      });

      return {
        snapshot_id: farm.snapshot_id,
        origem: farm.origem,
        snapshot_created_at: farm.snapshot_created_at,
        cache_expira_at: farm.cache_expira_at,
        cache_idade_segundos: farm.cache_idade_segundos,
        cache_ttl_minutos: farm.cache_ttl_minutos,
        fernando: this.compactarSaudeUsuarioDecisao(farm.fernando),
        diego: this.compactarSaudeUsuarioDecisao(farm.diego),
        resumo_24h: {
          origem: farm.resumo_24h ? farm.resumo_24h.origem : null,
          tipo: farm.resumo_24h ? farm.resumo_24h.tipo : null,
          multiplicador: farm.resumo_24h ? farm.resumo_24h.multiplicador : null,
          fernando: this.compactarSaudeUsuarioDecisao(farm.resumo_24h ? farm.resumo_24h.fernando : null)
        },
        performance_filtros_60m: {
          status: performance.status,
          origem: performance.origem,
          janela_minutos: performance.janela_minutos,
          periodo_inicio_at: performance.periodo_inicio_at,
          periodo_fim_at: performance.periodo_fim_at,
          referencia: performance.referencia,
          filtros: filtrosPerformance
        },
        benchmark_favoravel_diego: farm.benchmark_favoravel_diego
      };
    }

    private compactarSaudeUsuarioDecisao(saude: any): any {
      saude = saude || {};
      return {
        id_user: saude.id_user,
        periodo_inicio_at: saude.periodo_inicio_at,
        periodo_fim_at: saude.periodo_fim_at,
        lucro_previsto_sniper: saude.lucro_previsto_sniper,
        valor_investido: saude.valor_investido,
        venda_estimada: saude.venda_estimada,
        cartas_snipadas: saude.cartas_snipadas,
        classificacao: saude.classificacao,
        precos_pendentes_total: saude.precos_pendentes_total,
        periodo: saude.periodo,
        plataforma: saude.plataforma
      };
    }

    private compactarFiltroDecisao(filtro: any): any {
      filtro = filtro || {};
      const historico = filtro.historico_frequencia || {};

      return {
        id: filtro.id,
        slot_id: filtro.slot_id,
        slot_rank: filtro.slot_rank,
        slot_grupo: filtro.slot_grupo,
        tipo: filtro.tipo,
        modo: filtro.modo,
        nome: filtro.nome,
        resource_id: filtro.resource_id,
        asset_id: filtro.asset_id,
        rareflag: filtro.rareflag,
        id_plataforma: filtro.id_plataforma,
        id_filtro_copiar: filtro.id_filtro_copiar,
        total: filtro.total,
        quantidade_mais_fernando: filtro.quantidade_mais_fernando,
        lucro_unitario: filtro.lucro_unitario,
        lucro: filtro.lucro,
        maxBuyNow: filtro.maxBuyNow,
        variar: filtro.variar,
        preco: filtro.preco,
        valor_compra: filtro.valor_compra,
        rangeAbs: filtro.rangeAbs,
        filtro_assinatura: filtro.filtro_assinatura,
        assinatura_base: filtro.assinatura_base,
        dados_ea_resumo: filtro.dados_ea_resumo,
        status_antes: filtro.status_antes,
        status_depois: filtro.status_depois,
        aplicado: filtro.aplicado,
        motivo: filtro.motivo,
        historico_frequencia: {
          chave: historico.chave,
          positivos_ultimos_3: historico.positivos_ultimos_3,
          soma_ultimos_3: historico.soma_ultimos_3,
          fluxo_forte_sustentado: historico.fluxo_forte_sustentado,
          nivel_abertura_slot: historico.nivel_abertura_slot,
          fluxo_confirmado_abrir_slot: historico.fluxo_confirmado_abrir_slot,
          fluxo_muito_forte: historico.fluxo_muito_forte
        }
      };
    }

    private async aplicarControleMixInteligencia(): Promise<void> {
      if (!this.urlsInteligencia || !this.urlsInteligencia.controleFiltros || !this.ehLider()) {
        return;
      }

      try {
        const resposta: any = await this.postJson(this.urlsInteligencia.controleFiltros, {
          id_user: 7,
          estrategia: this.estrategia,
          instancia_token: this.getInstanciaToken(),
          classificacao: this.getClassificacaoCiclo(),
          motivo: this.getMotivoCiclo(),
          analise_mercado: this.getResumoAnaliseMercado(),
          farm_saude: this.farmSaude,
          protecao: this.protecaoMercado,
          filtros_padrao: this.filtrosHibridosSelecionados || [],
          filtros_multi: this.filtrosTopMultirraridadeSelecionados || [],
          filtros_status: this.estadoInteligencia && this.estadoInteligencia.filtros ? this.estadoInteligencia.filtros : null
        });

        if (resposta && resposta.controle) {
          this.controleMixFiltros = resposta.controle;
        }

        if (resposta && resposta.filtros) {
          if (!this.estadoInteligencia) {
            this.estadoInteligencia = {};
          }
          this.estadoInteligencia.filtros = resposta.filtros;
        }
      } catch (e) {
        console.warn('Falha ao aplicar controle de mix TopSniperFernando', e);
      }
    }

    private getClassificacaoCiclo(): string {
      if (this.protecaoBloqueiaSalvamento()) {
        return 'protecao_ativa';
      }

      const analise = this.analiseMercadoFernando || {};
      if (analise.modo === 'alta' && this.temPrecoFrescoOuSaudeBoa()) {
        return 'alta_valida';
      }

      if (analise.sinal === 'alto') {
        return 'alerta_sem_queda';
      }

      return 'operacao_normal';
    }

    private getMotivoCiclo(): string {
      if (this.protecaoBloqueiaSalvamento()) {
        return 'Protecao/quarentena ativa: observador nao salva novos filtros.';
      }

      if (!this.ehLider()) {
        return 'Instancia observadora: monitora e registra sem salvar filtros.';
      }

      return (this.analiseMercadoFernando && this.analiseMercadoFernando.motivo) ? this.analiseMercadoFernando.motivo : 'Operacao normal.';
    }

    private ehLider(): boolean {
      return !!(this.lideranca && this.lideranca.is_lider);
    }

    private protecaoBloqueiaSalvamento(): boolean {
      return !!(this.protecaoMercado && (this.protecaoMercado.ativa || this.protecaoMercado.bloqueia_salvamento));
    }

    private podeSalvarFiltrosAgora(): boolean {
      return this.ehLider() && !this.protecaoBloqueiaSalvamento();
    }

    private getStatusFiltroGerenciado(idFiltro: number): any {
      return this.estadoInteligencia
        && this.estadoInteligencia.filtros
        && this.estadoInteligencia.filtros.status
        && this.estadoInteligencia.filtros.status[idFiltro]
        ? this.estadoInteligencia.filtros.status[idFiltro]
        : null;
    }

    private getMotivoBloqueioFiltro(idFiltro: number): string {
      if (!this.ehLider()) {
        return 'observador';
      }

      if (this.protecaoBloqueiaSalvamento()) {
        return 'protecao_ativa';
      }

      const statusFiltro = this.getStatusFiltroGerenciado(idFiltro);
      if (statusFiltro && statusFiltro.inativo_manual) {
        return 'filtro_inativo_manual_editado_sem_ativar';
      }

      return 'aplicado';
    }

    private getClassificacaoSaudeFernando(): string {
      return this.farmSaude && this.farmSaude.fernando ? this.farmSaude.fernando.classificacao : null;
    }

    private deveAumentarPesoFrequenciaPorSaude(): boolean {
      const saude = this.getClassificacaoSaudeFernando();
      const mercadoMovimentado = this.analiseMercadoFernando
        && (this.analiseMercadoFernando.modo === 'alta' || this.analiseMercadoFernando.sinal === 'alto');

      return mercadoMovimentado && (saude === 'muito_baixo' || saude === 'medio');
    }

    private temPrecoFrescoOuSaudeBoa(): boolean {
      const saude = this.getClassificacaoSaudeFernando();
      return saude === 'bom' || saude === 'alto' || saude === 'muito_alto' || this.deveForcarPrecoFresco();
    }

    private deveForcarPrecoFresco(): boolean {
      const forcarAte = Number(sessionStorage.getItem(this.keyStorageForcarPrecoFresco) || 0);
      return isFinite(forcarAte) && forcarAte > Date.now();
    }

    private deveAguardarPrecoFrescoAntesDaAnalise(): boolean {
      return this.protecaoBloqueiaSalvamento() || this.deveForcarPrecoFresco();
    }

    private deveUsarFutggEmLote(): boolean {
      const analise = this.analiseMercadoFernando || {};
      const mercadoMovimentado = analise.modo === 'alta' || analise.sinal === 'alto';
      const saude = this.getClassificacaoSaudeFernando();
      const saudeRuim = saude === 'muito_baixo' || saude === 'medio';

      return this.ehLider()
        && !!this.urlsInteligencia
        && !!this.urlsInteligencia.futggSessao
        && !!this.opcoes.idExtensao
        && (this.protecaoBloqueiaSalvamento() || this.temBloqueioAssinaturaAtivo() || (mercadoMovimentado && saudeRuim) || this.deveForcarPrecoFresco());
    }

    private temBloqueioAssinaturaAtivo(): boolean {
      const bloqueios = this.estadoInteligencia
        && this.estadoInteligencia.bloqueios_assinatura
        && $.isArray(this.estadoInteligencia.bloqueios_assinatura.itens)
        ? this.estadoInteligencia.bloqueios_assinatura.itens
        : [];

      return bloqueios.some((bloqueio: any): boolean => bloqueio && bloqueio.ativo === true);
    }

    private async tentarAtualizarPrecosFutggEmLoteSeNecessario(): Promise<void> {
      if (!this.deveUsarFutggEmLote()) {
        return;
      }

      const ids = this.getResourceIdsParaPrecoFresco();
      if (!ids.length) {
        return;
      }

      try {
        const autorizacao = await this.postJson(this.urlsInteligencia.futggSessao, {
          id_user: 7,
          estrategia: this.estrategia,
          instancia_token: this.getInstanciaToken(),
          quantidade_ids: ids.length,
          ids: ids.slice(0, 80),
          motivo: 'alerta/protecao/revalidacao ou saude ruim com mercado alto'
        });

        if (!autorizacao || !autorizacao.status) {
          return;
        }

        await this.buscarPrecosFutggLoteNaExtensao(ids);
      } catch (e) {
        console.warn('Falha ao usar FutGG em lote TopSniperFernando', e);
      }
    }

    private getResourceIdsParaPrecoFresco(): number[] {
      const mapa: any = {};
      const cartas = (this.cartasPrecificadasMomento || [])
        .filter((carta: any) => this.ehCartaConsole(carta) && this.toNumber(carta.resource_id) > 0 && this.toNumber(carta.quantidade_mais_fernando) > 0)
        .sort((a: any, b: any) =>
          (this.toNumber(b.quantidade_mais_fernando) - this.toNumber(a.quantidade_mais_fernando)) ||
          (this.toNumber(b.lucro_unitario) - this.toNumber(a.lucro_unitario))
        );

      cartas.forEach((carta: any) => {
        mapa[this.toNumber(carta.resource_id)] = true;
      });

      return Object.keys(mapa).map((id: string) => Number(id)).filter((id: number) => id > 0).slice(0, 80);
    }

    private buscarPrecosFutggLoteNaExtensao(ids: number[]): Promise<void> {
      return new Promise((resolve: any) => {
        // A extensao pode nunca chamar o callback; sem timeout o await desta Promise
        // deixaria prepararTopCartas pendente para sempre.
        let respondido = false;
        let timeoutResposta: any = null;
        const finalizar = (): void => {
          if (respondido) {
            return;
          }

          respondido = true;
          if (timeoutResposta) {
            clearTimeout(timeoutResposta);
            timeoutResposta = null;
          }
          resolve();
        };

        timeoutResposta = setTimeout(finalizar, this.timeoutRespostaExtensao);

        try {
          chrome.runtime.sendMessage(this.opcoes.idExtensao, {
            evento: 'bpftb_lote',
            idsArray: ids,
            ehPc: false,
            quantidadePorRequisicao: 20,
            forcarPrecoFresco: true,
            ignorarCachePreco: true
          }, (resultado: any) => {
            const erroExtensao = chrome.runtime.lastError;
            const precos = !erroExtensao && resultado && resultado.status && $.isArray(resultado.response) ? resultado.response : [];
            this.registrarPrecosFutggLote(precos)
              .then((): void => {
                if (this.ehLider()) {
                  sessionStorage.setItem(this.keyStorageForcarPrecoFresco, (Date.now() + (2 * 60 * 1000)).toString());
                }
                finalizar();
              })
              .catch((): void => finalizar());
          });
        } catch (e) {
          finalizar();
        }
      });
    }

    private registrarPrecosFutggLote(itens: any[]): Promise<any> {
      if (!this.urlsInteligencia || !this.urlsInteligencia.preco || !$.isArray(itens) || !itens.length) {
        return Promise.resolve(null);
      }

      const precosPorChave: any = {};
      (itens || []).forEach((item: any): void => {
        if (!item) return;

        const resourceId = this.toNumber(item.eaId || item.resourceId || item.id);
        const preco = this.toNumber(item.price || item.preco);
        if (!resourceId || preco <= 0) {
          return;
        }

        const idPlataforma = 1;
        precosPorChave[`${resourceId}|${idPlataforma}`] = {
          resource_id: resourceId,
          id_plataforma: idPlataforma,
          preco: preco,
          metadata: item
        };
      });

      const precos = Object.keys(precosPorChave).map((chave: string): any => precosPorChave[chave]);
      if (!precos.length) {
        return Promise.resolve(null);
      }

      return this.postJson(this.urlsInteligencia.preco, {
        id_user: 7,
        instancia_token: this.getInstanciaToken(),
        fonte: 'futgg_lote',
        forcar_preco_fresco: this.ehLider(),
        precos: precos
      });
    }

    public static salvarFiltroFernando(id: number, cartaDoFiltro: ICartaTopSniper, todasCartasSelecionadas: ICartaTopSniper[], lucroMinimoUnitarioCartasRelacionadas: number, totalCartasRelacionadasJuntarNoFiltro: number, urlUpdateFiltro: string) {
      let valorCompraCarta = Util.getPrecoVariacaoMax(TopSniperUtil.getMenorPreco(cartaDoFiltro.valor_all, cartaDoFiltro.valor), TopSniperUtil.getIncrementoPrecoCompraFernando(cartaDoFiltro.valor))
      let idsCartasMesmaRaridades = [];

      if (totalCartasRelacionadasJuntarNoFiltro) {
        idsCartasMesmaRaridades = TopSniperUtil.filtrarCartarRelacionadasPorRaridade(cartaDoFiltro.asset_id, todasCartasSelecionadas, cartaDoFiltro.raridade.id, valorCompraCarta, lucroMinimoUnitarioCartasRelacionadas).map((item: any) => item.asset_id)
        // se idsCartasMesmaRaridades for maior que o totalCartasRelacionadasJuntarNoFiltro, então pego apenas o totalCartasRelacionadasJuntarNoFiltro
        if (idsCartasMesmaRaridades.length >= totalCartasRelacionadasJuntarNoFiltro) {
          idsCartasMesmaRaridades = idsCartasMesmaRaridades.slice(0, totalCartasRelacionadasJuntarNoFiltro)
        }

        // se existir idsCartasMesmaRaridades, então adiciono a carta principal cartaDoFiltro.asset_id junta a lista
        if (idsCartasMesmaRaridades.length) {
          idsCartasMesmaRaridades.push(cartaDoFiltro.asset_id)
        }
      }

      TopSniperUtil.salvarFiltroPiloto(urlUpdateFiltro, {
        id: id,
        variar: TopSniperUtil.getVariacaoFiltroFernando(cartaDoFiltro.valor),
        maxBuyNow: valorCompraCarta,
        maskedDefId: idsCartasMesmaRaridades.length ? idsCartasMesmaRaridades : [cartaDoFiltro.asset_id],
        rarity: [cartaDoFiltro.rareflag]
      });
    }

    public static salvarFiltroFernandoPorQualidade(id: number, cartaDoFiltro: ICartaTopSniper, todasCartasSelecionadas: ICartaTopSniper[], lucroMinimoUnitarioCartasRelacionadas: number, totalCartasRelacionadasJuntarNoFiltro: number, urlUpdateFiltro: string) {
      let valorCompraCarta = Util.getPrecoVariacaoMax(TopSniperUtil.getMenorPreco(cartaDoFiltro.valor_all, cartaDoFiltro.valor), TopSniperUtil.getIncrementoPrecoCompraFernando(cartaDoFiltro.valor))

      TopSniperUtil.salvarFiltroPiloto(urlUpdateFiltro, {
        id: id,
        variar: TopSniperUtil.getVariacaoFiltroFernando(cartaDoFiltro.valor),
        maxBuyNow: valorCompraCarta,
        maskedDefId: [cartaDoFiltro.asset_id],
        quality: "SP"
      });
    }

    private iniciandoAnaliseTopcartas() {
      // valor é o valor de compra
      // preco é o preço de venda
      // total é quantidade de cartas total encontrada
      // quantidade_mais é a quantidade de cartas encontrada a mais da ultima vez que filtrei
      // lucro_unitario é quanto de lucro a carta me dará apos ser vendida

      this.metodoTopCartasPilotoPrincipalHibrido()
      // Escopo da inteligencia nova: apenas filtros padrao 50105/50311/50557/53982 e multi-raridade 57554/59226.
    }
    private analisarMercadoFernando(): any {
      const agora = Date.now();
      const dadosAtuais = this.getDadosSnipersBrutos();
      const snapshotAnterior = this.getStorageJson(this.keyStorageSnapshotFrequencia, {});
      const snapshotAtual = this.criarSnapshotFrequencia(dadosAtuais);
      const primeiroCarregamento = !snapshotAnterior || Object.keys(snapshotAnterior).length === 0;
      const mapaQuantidadeMais: any = {};
      let somaQuantidadeMais = 0;
      let cartasUnicasComAumento = 0;
      let cartasNovasNoSnapshot = 0;

      Object.keys(snapshotAtual).forEach((chave: string) => {
        const atual = snapshotAtual[chave];
        const anterior = snapshotAnterior[chave];
        const totalAtual = this.getTotalSnapshotFrequencia(atual);
        const totalAnterior = anterior ? this.getTotalSnapshotFrequencia(anterior) : 0;
        const quantidadeMais = primeiroCarregamento ? 0 : Math.max(totalAtual - totalAnterior, 0);

        mapaQuantidadeMais[chave] = quantidadeMais;
        somaQuantidadeMais += quantidadeMais;

        if (quantidadeMais > 0) {
          cartasUnicasComAumento++;
        }

        if (!primeiroCarregamento && !anterior) {
          cartasNovasNoSnapshot++;
        }
      });

      const sinal = primeiroCarregamento ? 'neutro' : this.getSinalMercado(somaQuantidadeMais, cartasUnicasComAumento);
      const historicoAnterior = this.getStorageJson(this.keyStorageHistoricoMercado, []);
      const historicoAtual = this.atualizarHistoricoMercado(historicoAnterior, {
        horario: agora,
        soma_quantidade_mais: somaQuantidadeMais,
        cartas_unicas_com_aumento: cartasUnicasComAumento,
        cartas_novas_no_snapshot: cartasNovasNoSnapshot,
        sinal: sinal
      });
      const decisao = this.decidirModoMercado(sinal, somaQuantidadeMais, historicoAtual, primeiroCarregamento, agora);
      const historicoFrequenciaCartas = this.atualizarHistoricoFrequenciaCartas(snapshotAtual, mapaQuantidadeMais, agora);

      this.historicoFrequenciaCartasMemoria = historicoFrequenciaCartas;
      // O storage passa a valer o historico recem-calculado: mantem a leitura por carta
      // identica a antes, mas sem reparsear o localStorage a cada carta.
      this.historicoFrequenciaCartasStorage = historicoFrequenciaCartas;
      this.setStorageJsonSeguro(this.keyStorageSnapshotFrequencia, snapshotAtual);
      this.setStorageJsonSeguro(this.keyStorageHistoricoMercado, historicoAtual);
      this.setStorageJsonSeguro(this.keyStorageHistoricoFrequenciaCartas, historicoFrequenciaCartas);
      this.setStorageValorSeguro(this.keyStorageModoMercado, decisao.modo);

      return {
        primeiroCarregamento: primeiroCarregamento,
        modo: decisao.modo,
        modoAnterior: decisao.modoAnterior,
        sinal: sinal,
        motivo: decisao.motivo,
        minutosSemAlta: decisao.minutosSemAlta,
        soma_quantidade_mais: somaQuantidadeMais,
        cartas_unicas_com_aumento: cartasUnicasComAumento,
        cartas_novas_no_snapshot: cartasNovasNoSnapshot,
        total_cartas_snapshot: Object.keys(snapshotAtual).length,
        mapaQuantidadeMais: mapaQuantidadeMais,
        historico: historicoAtual,
        limites: this.configuracoesHibrido,
        fonte: 'total DISTINCT trade_id agregado'
      };
    }

    private getDadosSnipersBrutos(): any[] {
      const dados = $('#cardDadosSnipers').data('dadosSnipers');
      return $.isArray(dados) ? dados : [];
    }

    private criarSnapshotFrequencia(dadosSnipers: any[]): any {
      const snapshot: any = {};

      (dadosSnipers || []).forEach((carta: any) => {
        if (!this.ehCartaConsole(carta)) return;

        const chave = this.getChaveFrequenciaCarta(carta);
        if (!chave) return;

        snapshot[chave] = this.toNumber(carta.total);
      });

      return snapshot;
    }

    private aplicarFrequenciaFernando(cartas: ICartaTopSniper[], mapaQuantidadeMais: any): void {
      (cartas || []).forEach((carta: any) => {
        const chave = this.getChaveFrequenciaCarta(carta);
        const quantidadeMais = this.toNumber(mapaQuantidadeMais && mapaQuantidadeMais.hasOwnProperty(chave) ? mapaQuantidadeMais[chave] : 0);

        carta.quantidade_mais_fernando = quantidadeMais;
        carta.tem_aumento_fernando = quantidadeMais > 0;
        carta.quantidade_mais = quantidadeMais;
        carta.historico_frequencia = this.getHistoricoFrequenciaCarta(carta);
      });
    }

    private getSinalMercado(somaQuantidadeMais: number, cartasUnicasComAumento: number): string {
      if (somaQuantidadeMais >= this.configuracoesHibrido.alta.soma_quantidade_mais || cartasUnicasComAumento >= this.configuracoesHibrido.alta.cartas_unicas_com_aumento) {
        return 'alto';
      }

      if (somaQuantidadeMais <= this.configuracoesHibrido.baixa.soma_quantidade_mais && cartasUnicasComAumento <= this.configuracoesHibrido.baixa.cartas_unicas_com_aumento) {
        return 'baixo';
      }

      return 'neutro';
    }

    private atualizarHistoricoMercado(historicoAnterior: any[], ciclo: any): any[] {
      const historico = ($.isArray(historicoAnterior) ? historicoAnterior : []).concat([ciclo]);
      return historico.slice(-this.configuracoesHibrido.historico.max_ciclos);
    }

    private atualizarHistoricoFrequenciaCartas(snapshotAtual: any, mapaQuantidadeMais: any, agora: number): any {
      const historicoAnterior = this.getHistoricoFrequenciaCartasStorage();
      const historico: any = {};
      const limiteAntigo = agora - (2 * 60 * 60 * 1000);
      const maxCiclosPorCarta = 6;
      const maxCartasHistorico = 600;
      const chavesCandidatas: any[] = [];

      Object.keys(snapshotAtual || {}).forEach((chave: string) => {
        const ciclosAnteriores = $.isArray(historicoAnterior[chave]) ? historicoAnterior[chave] : [];
        const ciclosRecentes = ciclosAnteriores.filter((ciclo: any): boolean => this.toNumber(ciclo.horario) >= limiteAntigo);
        const quantidadeMaisAtual = this.toNumber(mapaQuantidadeMais && mapaQuantidadeMais.hasOwnProperty(chave) ? mapaQuantidadeMais[chave] : 0);
        if (quantidadeMaisAtual <= 0 && !ciclosRecentes.length) {
          return;
        }

        chavesCandidatas.push({
          chave: chave,
          quantidade_mais: quantidadeMaisAtual,
          total: this.getTotalSnapshotFrequencia(snapshotAtual[chave]),
          ciclos: ciclosRecentes
        });
      });

      chavesCandidatas
        .sort((a: any, b: any): number =>
          (this.toNumber(b.quantidade_mais) - this.toNumber(a.quantidade_mais)) ||
          (this.toNumber(b.total) - this.toNumber(a.total))
        )
        .slice(0, maxCartasHistorico)
        .forEach((registro: any): void => {
          const chave = registro.chave;
          const dadosChave = this.getDadosChaveFrequenciaCarta(chave);
          const totalAtual = this.getTotalSnapshotFrequencia(snapshotAtual[chave]);
          const quantidadeMaisAtual = this.toNumber(mapaQuantidadeMais && mapaQuantidadeMais.hasOwnProperty(chave) ? mapaQuantidadeMais[chave] : 0);
          const ciclos = $.isArray(registro.ciclos) ? registro.ciclos : [];
          ciclos.push({
            horario: agora,
            total: totalAtual,
            quantidade_mais: quantidadeMaisAtual,
            resource_id: dadosChave.resource_id,
            rareflag: dadosChave.rareflag,
            id_plataforma: dadosChave.id_plataforma
          });

          historico[chave] = ciclos
            .filter((ciclo: any): boolean => this.toNumber(ciclo.horario) >= limiteAntigo)
            .slice(-maxCiclosPorCarta);
        });

      return historico;
    }

    private getTotalSnapshotFrequencia(item: any): number {
      if (typeof item === 'number' || typeof item === 'string') {
        return this.toNumber(item);
      }

      return this.toNumber(item && item.total);
    }

    private getDadosChaveFrequenciaCarta(chave: string): any {
      const partes = (chave || '').split('|');
      return {
        resource_id: this.toNumber(partes[0]),
        rareflag: this.toNumber(partes[1]),
        id_plataforma: this.toNumber(partes[2])
      };
    }

    private getHistoricoFrequenciaCartasStorage(): any {
      if (this.historicoFrequenciaCartasStorage === null) {
        const dados = this.getStorageJson(this.keyStorageHistoricoFrequenciaCartas, {});
        this.historicoFrequenciaCartasStorage = dados && typeof dados === 'object' ? dados : {};
      }

      return this.historicoFrequenciaCartasStorage;
    }

    private getHistoricoFrequenciaCarta(carta: any): any {
      const chave = this.getChaveFrequenciaCarta(carta);
      const historicoMemoria = chave && this.historicoFrequenciaCartasMemoria ? this.historicoFrequenciaCartasMemoria[chave] : null;
      const historicoStorage = chave && !historicoMemoria ? this.getHistoricoFrequenciaCartasStorage()[chave] : [];
      const historico = historicoMemoria || historicoStorage;
      const ciclos = $.isArray(historico) ? historico : [];
      const ultimos = ciclos.slice(-3);
      const positivos = ultimos.filter((ciclo: any): boolean => this.toNumber(ciclo.quantidade_mais) > 0);
      const soma = ultimos.reduce((total: number, ciclo: any): number => total + this.toNumber(ciclo.quantidade_mais), 0);

      return {
        chave: chave,
        ultimos_ciclos: ultimos,
        positivos_ultimos_3: positivos.length,
        soma_ultimos_3: soma,
        fluxo_forte_sustentado: positivos.length >= 3,
        nivel_abertura_slot: this.getNivelAberturaSlot(ultimos),
        fluxo_confirmado_abrir_slot: this.temFluxoConfirmadoAbrirSlot(ultimos),
        fluxo_muito_forte: positivos.length >= 3 && soma >= 5
      };
    }

    private getNivelAberturaSlot(ciclos: any[]): number {
      const ultimos = ($.isArray(ciclos) ? ciclos : []).slice(-3);
      if (ultimos.length < 3) {
        return 0;
      }

      const primeiro = this.toNumber(ultimos[0].quantidade_mais);
      const segundo = this.toNumber(ultimos[1].quantidade_mais);
      const terceiro = this.toNumber(ultimos[2].quantidade_mais);

      if (primeiro >= 1 && segundo >= 1 && terceiro >= 1) {
        return 4;
      }

      return 0;
    }

    private temFluxoConfirmadoAbrirSlot(ciclos: any[]): boolean {
      return this.getNivelAberturaSlot(ciclos) >= 3;
    }

    private decidirModoMercado(sinal: string, somaQuantidadeMais: number, historico: any[], primeiroCarregamento: boolean, agora: number): any {
      const modoAnterior = localStorage.getItem(this.keyStorageModoMercado) || 'baixa';
      const ultimoCicloAlto = this.getUltimoCicloAlto(historico);
      const minutosSemAlta = ultimoCicloAlto ? Math.floor((agora - this.toNumber(ultimoCicloAlto.horario)) / 60000) : null;
      const ultimosCiclosEntrada = historico.slice(-this.configuracoesHibrido.alta.janela_ciclos_entrada);
      const totalAltosEntrada = ultimosCiclosEntrada.filter((item: any) => item.sinal === 'alto').length;

      if (primeiroCarregamento) {
        return {
          modo: 'baixa',
          modoAnterior: modoAnterior,
          minutosSemAlta: minutosSemAlta,
          motivo: 'Primeiro carregamento: snapshot salvo para comparar o proximo ciclo.'
        };
      }

      if (somaQuantidadeMais >= this.configuracoesHibrido.alta.soma_muito_forte) {
        return {
          modo: 'alta',
          modoAnterior: modoAnterior,
          minutosSemAlta: 0,
          motivo: 'Entrou em alta por ciclo muito forte.'
        };
      }

      if (totalAltosEntrada >= this.configuracoesHibrido.alta.ciclos_altos_para_entrar) {
        return {
          modo: 'alta',
          modoAnterior: modoAnterior,
          minutosSemAlta: minutosSemAlta,
          motivo: 'Entrou em alta por recorrencia nos ultimos ciclos.'
        };
      }

      if (modoAnterior === 'alta') {
        if (sinal === 'baixo' && minutosSemAlta !== null && minutosSemAlta >= this.configuracoesHibrido.baixa.minutos_sem_alta_para_sair) {
          return {
            modo: 'baixa',
            modoAnterior: modoAnterior,
            minutosSemAlta: minutosSemAlta,
            motivo: 'Saiu da alta apos baixa sustentada por tempo suficiente.'
          };
        }

        return {
          modo: 'alta',
          modoAnterior: modoAnterior,
          minutosSemAlta: minutosSemAlta,
          motivo: 'Segurou alta para evitar troca por oscilacao curta.'
        };
      }

      return {
        modo: 'baixa',
        modoAnterior: modoAnterior,
        minutosSemAlta: minutosSemAlta,
        motivo: sinal === 'neutro' ? 'Mercado neutro: manteve baixa ate confirmar alta.' : 'Mercado baixo.'
      };
    }

    private getUltimoCicloAlto(historico: any[]): any {
      for (let i = historico.length - 1; i >= 0; i--) {
        if (historico[i].sinal === 'alto') {
          return historico[i];
        }
      }

      return null;
    }

    private getChaveFrequenciaCarta(carta: any): string {
      if (!carta) return null;

      const resourceId = this.toNumber(carta.resource_id);
      const rareflag = this.toNumber(carta.rareflag);
      const idPlataforma = this.normalizarPlataformaConsole(carta.id_plataforma);

      if (!resourceId || !Number.isFinite(resourceId)) return null;
      if (!Number.isFinite(rareflag)) return null;
      if (!Number.isFinite(idPlataforma)) return null;

      return `${resourceId}|${rareflag}|${idPlataforma}`;
    }

    private ehCartaConsole(carta: any): boolean {
      const idPlataforma = this.normalizarPlataformaConsole(carta && carta.id_plataforma);
      return idPlataforma === 1 || idPlataforma === 2;
    }

    private getStorageJson(key: string, fallback: any): any {
      try {
        const item = localStorage.getItem(key);
        return item ? JSON.parse(item) : fallback;
      } catch (e) {
        return fallback;
      }
    }

    private setStorageJsonSeguro(key: string, value: any): boolean {
      try {
        localStorage.setItem(key, JSON.stringify(value));
        return true;
      } catch (e) {
        this.limparStoragePesadoTopSniperFernando(key);
        try {
          localStorage.removeItem(key);
        } catch (erroRemoveAtual) { }
        try {
          localStorage.setItem(key, JSON.stringify(value));
          return true;
        } catch (erroRetry) {
          try {
            localStorage.removeItem(key);
          } catch (erroLimpeza) { }
          return false;
        }
      }
    }

    private setStorageValorSeguro(key: string, value: any): boolean {
      try {
        localStorage.setItem(key, String(value));
        return true;
      } catch (e) {
        this.limparStoragePesadoTopSniperFernando(key);
        try {
          localStorage.removeItem(key);
        } catch (erroRemoveAtual) { }
        try {
          localStorage.setItem(key, String(value));
          return true;
        } catch (erroRetry) {
          return false;
        }
      }
    }

    private limparStoragePesadoTopSniperFernando(chaveAtual: string): void {
      [
        'dataTopSnipers',
        'dataTopSnipersCompacto',
        this.keyStorageHistoricoFrequenciaCartas,
        this.keyStorageHistoricoCandidatosPadrao,
        this.keyStorageHistoricoCandidatosMulti,
        this.keyStorageCartasArmazenadas
      ].forEach((chave: string): void => {
        if (chave === chaveAtual) {
          return;
        }

        try {
          localStorage.removeItem(chave);
        } catch (e) { }
      });
    }

    private toNumber(valor: any): number {
      if (valor === null || typeof valor === 'undefined' || valor === '') return 0;

      const numero = typeof valor === 'string' ? Number(valor.replace(',', '.')) : Number(valor);
      return Number.isFinite(numero) ? numero : 0;
    }

    private normalizarPlataformaConsole(idPlataforma: any): number {
      const id = this.toNumber(idPlataforma);
      return id === 0 ? 1 : id;
    }

    private getSlotRank(id: number): number {
      const ranks: any = {
        50105: 1,
        50311: 2,
        50557: 3,
        53982: 4,
        57554: 1,
        59226: 2
      };

      return ranks[id] ? ranks[id] : 0;
    }

    private getPrecoBucket(valor: number, tamanho: number = 5000): number {
      const numero = this.toNumber(valor);
      if (numero <= 0) return 0;

      return Math.floor(numero / tamanho) * tamanho;
    }

    private criarAssinaturaFiltroPadrao(carta: any, valorCompra: number, variacao: number): any {
      const resourceId = this.toNumber(carta && carta.resource_id);
      const assetId = this.toNumber(carta && carta.asset_id);
      const rareflag = this.toNumber(carta && carta.rareflag);
      const idPlataforma = this.normalizarPlataformaConsole(carta && carta.id_plataforma);
      const precoBucket = this.getPrecoBucket(valorCompra);
      const assinaturaBase = `padrao|resource:${resourceId}|asset:${assetId}|rare:${rareflag}|plat:${idPlataforma}`;
      const assinatura = `${assinaturaBase}|buy:${precoBucket}|variar:${variacao}`;

      return {
        filtro_assinatura: assinatura,
        assinatura_base: assinaturaBase,
        dados_ea_resumo: {
          maskedDefId: assetId ? [assetId] : [],
          rarity: rareflag ? [rareflag] : [],
          maxBuyNow: valorCompra,
          maxBuyNow_bucket: precoBucket,
          variar: variacao,
          id_plataforma: idPlataforma
        }
      };
    }

    private criarAssinaturaFiltroMulti(filtro: any): any {
      const idOrigem = this.toNumber(filtro && filtro.id_filtro);
      const rangeBucket = this.getPrecoBucket(this.toNumber(filtro && filtro.rangeAbs));
      const dadosFiltro = this.getDadosFiltroTop(filtro);
      const dadosResumo = this.criarResumoDadosFiltroTop(dadosFiltro);
      const dadosHash = this.hashTextoSimples(this.normalizarTextoAssinatura(dadosFiltro));
      const assinaturaBase = `multi|origem:${idOrigem}|dados:${dadosHash}`;
      const assinatura = `${assinaturaBase}|range:${rangeBucket}`;

      return {
        filtro_assinatura: assinatura,
        assinatura_base: assinaturaBase,
        dados_ea_hash: dadosHash,
        dados_ea_resumo: dadosResumo
      };
    }

    private normalizarTextoAssinatura(valor: any): string {
      if (valor === null || typeof valor === 'undefined') return '';
      if (typeof valor === 'string') return valor;

      try {
        return JSON.stringify(valor);
      } catch (e) {
        return String(valor);
      }
    }

    private hashTextoSimples(texto: string): string {
      let hash = 5381;
      const valor = texto || '';
      for (let i = 0; i < valor.length; i++) {
        hash = ((hash << 5) + hash) + valor.charCodeAt(i);
        hash = hash & hash;
      }

      return Math.abs(hash).toString(16);
    }

    private metodoTopCartasPilotoPrincipalHibrido(): void {
      const analise = this.analiseMercadoFernando || this.analisarMercadoFernando();
      const modo = analise.modo === 'alta' || this.deveAumentarPesoFrequenciaPorSaude() ? 'alta' : 'baixa';
      const cartas = this.getCartasInteresseFiltrosPrincipaisHibrido(modo);
      this.filtrosHibridosSelecionados = [];

      TopSniperUtil.logTopSniper('TOPSNIPER FERNANDO HIBRIDO', { analise: analise, cartas: cartas });

      this.processarCartasHibridas(cartas.slice(0, 4), modo);
    }

    private getCartasInteresseFiltrosPrincipaisHibrido(modo: string): ICartaTopSniper[] {
      const cartas = (this.cartasPrecificadasMomento || [])
        .filter((carta: any) => this.cartaPassaFiltroHibrido(carta));

      this.registrarHistoricoCandidatosPadrao(cartas);

      if (this.deveUsarFallbackHistorico()) {
        const historico = this.getCartasHistoricoFallbackPadrao();
        if (historico.length) {
          return this.removerCartasDuplicadasPorFiltroEa(historico);
        }
      }

      return this.removerCartasDuplicadasPorFiltroEa(
        cartas.sort((a: any, b: any): number => this.compararCartasMomentoHibrido(a, b, this.deveUsarFallbackHistorico()))
      );
    }

    private compararCartasMomentoHibrido(a: any, b: any, fallbackHistorico: boolean = false): number {
      const sustentadoA = this.cartaTemFluxoSustentado(a) ? 1 : 0;
      const sustentadoB = this.cartaTemFluxoSustentado(b) ? 1 : 0;

      if (fallbackHistorico) {
        return (this.toNumber(b.score_fallback_historico) - this.toNumber(a.score_fallback_historico)) ||
          (this.toNumber(b.lucro_unitario) - this.toNumber(a.lucro_unitario)) ||
          (this.toNumber(b.lucro) - this.toNumber(a.lucro)) ||
          (this.toNumber(b.total) - this.toNumber(a.total));
      }

      const diferencaQuantidade = this.toNumber(b.quantidade_mais_fernando) - this.toNumber(a.quantidade_mais_fernando);
      if (diferencaQuantidade) return diferencaQuantidade;

      const diferencaSustentado = sustentadoB - sustentadoA;
      if (diferencaSustentado) return diferencaSustentado;

      if (sustentadoA && sustentadoB) {
        return (this.toNumber(b.lucro) - this.toNumber(a.lucro)) ||
          (this.toNumber(b.total) - this.toNumber(a.total)) ||
          (this.toNumber(b.valor) - this.toNumber(a.valor)) ||
          (this.toNumber(b.preco) - this.toNumber(a.preco));
      }

      return (this.toNumber(b.total) - this.toNumber(a.total)) ||
        (this.toNumber(b.lucro) - this.toNumber(a.lucro)) ||
        (this.toNumber(b.valor) - this.toNumber(a.valor)) ||
        (this.toNumber(b.preco) - this.toNumber(a.preco));
    }

    private cartaTemFluxoSustentado(carta: any): boolean {
      const historico = carta && carta.historico_frequencia ? carta.historico_frequencia : this.getHistoricoFrequenciaCarta(carta);
      return !!(historico && historico.fluxo_forte_sustentado);
    }

    private removerCartasDuplicadasPorFiltroEa(cartas: any[]): any[] {
      const vistos: any = {};
      const unicas: any[] = [];

      (cartas || []).forEach((carta: any): void => {
        const chave = this.getChaveFiltroEaCarta(carta);
        if (chave && vistos[chave]) {
          return;
        }

        if (chave) {
          vistos[chave] = true;
        }
        unicas.push(carta);
      });

      return unicas;
    }

    private getChaveFiltroEaCarta(carta: any): string {
      if (!carta) return null;

      const assetId = this.toNumber(carta.asset_id);
      const rareflag = this.toNumber(carta.rareflag);
      if (assetId && rareflag) {
        return `asset:${assetId}|rare:${rareflag}`;
      }

      const resourceId = this.toNumber(carta.resource_id);
      return resourceId && rareflag ? `resource:${resourceId}|rare:${rareflag}` : null;
    }

    private deveUsarFallbackHistorico(): boolean {
      const analise = this.analiseMercadoFernando || {};
      const minutos = analise.minutosSemAlta === null || typeof analise.minutosSemAlta === 'undefined'
        ? null
        : this.toNumber(analise.minutosSemAlta);

      return minutos !== null && minutos >= 120 && this.toNumber(analise.soma_quantidade_mais) <= this.configuracoesHibrido.baixa.soma_quantidade_mais;
    }

    private registrarHistoricoCandidatosPadrao(cartas: any[]): void {
      const agora = Date.now();
      const limiteAntigo = agora - (24 * 60 * 60 * 1000);
      const historico = this.getStorageJson(this.keyStorageHistoricoCandidatosPadrao, []);
      const registros = $.isArray(historico) ? historico : [];
      const cartasHistorico = (cartas || [])
        .slice()
        .sort((a: any, b: any): number => this.compararCartasMomentoHibrido(a, b, false))
        .slice(0, 80);

      cartasHistorico.forEach((carta: any) => {
        registros.push({
          horario: agora,
          chave: this.getChaveFrequenciaCarta(carta),
          carta: this.compactarCartaHistoricoFallback(carta),
          quantidade_mais_fernando: this.toNumber(carta.quantidade_mais_fernando),
          total: this.toNumber(carta.total),
          lucro_unitario: this.toNumber(carta.lucro_unitario),
          lucro: this.toNumber(carta.lucro)
        });
      });

      this.setStorageJsonSeguro(
        this.keyStorageHistoricoCandidatosPadrao,
        registros.filter((item: any): boolean => this.toNumber(item.horario) >= limiteAntigo).slice(-240)
      );
    }

    private getCartasHistoricoFallbackPadrao(): ICartaTopSniper[] {
      const agora = Date.now();
      const registros = this.getStorageJson(this.keyStorageHistoricoCandidatosPadrao, []);
      const porChave: any = {};

      ($.isArray(registros) ? registros : []).forEach((item: any) => {
        const idadeHoras = (agora - this.toNumber(item.horario)) / (60 * 60 * 1000);
        if (idadeHoras < 0 || idadeHoras > 24 || !item.chave || !item.carta) return;

        const peso = idadeHoras <= 6 ? 1 : (idadeHoras <= 12 ? 0.6 : 0.25);
        const score = ((this.toNumber(item.quantidade_mais_fernando) * 100000)
          + (this.toNumber(item.total) * 1000)
          + (this.toNumber(item.lucro) / 100)
          + this.toNumber(item.lucro_unitario)) * peso;

        if (!porChave[item.chave] || score > porChave[item.chave].score) {
          const carta = item.carta;
          carta.origem_fallback_historico = '6h_12h_24h';
          carta.score_fallback_historico = score;
          porChave[item.chave] = { score: score, carta: carta };
        }
      });

      return Object.keys(porChave)
        .map((chave: string): any => porChave[chave].carta)
        .filter((carta: any): boolean => this.cartaPassaFiltroHibrido(carta))
        .sort((a: any, b: any) => this.toNumber(b.score_fallback_historico) - this.toNumber(a.score_fallback_historico))
        .filter((carta: any, index: number, cartas: any[]): boolean => {
          const chave = this.getChaveFiltroEaCarta(carta);
          return !chave || cartas.findIndex((item: any): boolean => this.getChaveFiltroEaCarta(item) === chave) === index;
        })
        .slice(0, 4) as ICartaTopSniper[];
    }

    private clonarObjetoSimples(obj: any): any {
      try {
        return JSON.parse(JSON.stringify(obj));
      } catch (e) {
        return obj;
      }
    }

    private compactarCartaHistoricoFallback(carta: any): any {
      carta = carta || {};
      return {
        nome: carta.nome,
        resource_id: carta.resource_id,
        asset_id: carta.asset_id,
        rareflag: carta.rareflag,
        id_plataforma: this.normalizarPlataformaConsole(carta.id_plataforma),
        total: this.toNumber(carta.total),
        valor: this.toNumber(carta.valor),
        valor_all: carta.valor_all,
        preco: this.toNumber(carta.preco),
        lucro_unitario: this.toNumber(carta.lucro_unitario),
        lucro: this.toNumber(carta.lucro),
        quantidade_mais_fernando: this.toNumber(carta.quantidade_mais_fernando),
        quantidade_mais: this.toNumber(carta.quantidade_mais),
        tem_aumento_fernando: carta.tem_aumento_fernando === true
      };
    }

    private cartaPassaFiltroHibrido(carta: any): boolean {
      const valor = this.toNumber(carta.valor);
      const preco = this.toNumber(carta.preco);
      const lucroUnitario = this.toNumber(carta.lucro_unitario);
      const lucro = this.toNumber(carta.lucro);
      const quantidadeMaisFernando = this.toNumber(carta.quantidade_mais_fernando);
      const rareflag = this.toNumber(carta.rareflag);

      return this.ehCartaConsole(carta)
        && preco > 0
        && quantidadeMaisFernando > 0
        && preco > valor * 1.3
        && lucroUnitario >= this.configuracoes.piloto.principal.lucro_unitario_minimo
        && lucro > 0
        && valor >= this.configuracoes.piloto.principal.preco_compra_carta_acima_de
        && valor <= this.configuracoes.piloto.principal.valor_caixa_maximo
        && rareflag >= this.configuracoes.piloto.principal.raridade_minima_piloto_principal
        && !TopSniperFernando.excludesAssetId.includes(parseInt(carta.asset_id as any))
        && !TopSniperFernando.excludesRareFlag.includes(parseInt(carta.rareflag as any))
        && !this.cartaTemBloqueioAssinaturaAtivo(carta);
    }

    private cartaTemBloqueioAssinaturaAtivo(carta: any): boolean {
      const bloqueios = this.estadoInteligencia
        && this.estadoInteligencia.bloqueios_assinatura
        && $.isArray(this.estadoInteligencia.bloqueios_assinatura.itens)
        ? this.estadoInteligencia.bloqueios_assinatura.itens
        : [];

      if (!bloqueios.length) {
        return false;
      }

      const resourceId = this.toNumber(carta && carta.resource_id);
      const assetId = this.toNumber(carta && carta.asset_id);
      const rareflag = this.toNumber(carta && carta.rareflag);
      const idPlataforma = this.normalizarPlataformaConsole(carta && carta.id_plataforma);

      if (!resourceId) {
        return false;
      }

      return bloqueios.some((bloqueio: any): boolean => {
        if (!bloqueio || bloqueio.ativo !== true) {
          return false;
        }
        if (bloqueio.bloqueado_frontend === false) {
          return false;
        }

        const tipo = bloqueio.tipo ? String(bloqueio.tipo) : '';
        if (tipo && tipo !== 'padrao') {
          return false;
        }

        const bloqueioResourceId = this.toNumber(bloqueio.resource_id);
        if (bloqueioResourceId !== resourceId) {
          return false;
        }

        const bloqueioAssetId = this.toNumber(bloqueio.asset_id);
        if (bloqueioAssetId && assetId && bloqueioAssetId !== assetId) {
          return false;
        }

        const bloqueioRareflag = this.toNumber(bloqueio.rareflag);
        if (bloqueioRareflag && rareflag && bloqueioRareflag !== rareflag) {
          return false;
        }

        const bloqueioPlataformaValor = this.toNumber(bloqueio.id_plataforma);
        const bloqueioPlataforma = bloqueioPlataformaValor ? this.normalizarPlataformaConsole(bloqueioPlataformaValor) : 0;
        if (bloqueioPlataforma && idPlataforma && bloqueioPlataforma !== idPlataforma) {
          return false;
        }

        return true;
      });
    }

    private processarCartasHibridas(cartas: ICartaTopSniper[], modo: string): void {
      const filtros = [
        this.configuracoes.filtros.id_filtro_especial_piloto_a,
        this.configuracoes.filtros.id_filtro_especial_piloto_b,
        this.configuracoes.filtros.id_filtro_especial_piloto_c,
        this.configuracoes.filtros.id_filtro_especial_piloto_d
      ];

      (cartas || []).forEach((carta: ICartaTopSniper, index: number) => {
        if (!carta || !filtros[index]) return;

        this.salvarFiltroFernandoHibrido(filtros[index], carta, modo);
      });
    }

    private salvarFiltroFernandoHibrido(id: number, cartaDoFiltro: ICartaTopSniper, modo: string): void {
      const maxBuyNowBase = this.calcularMaxBuyNowHibrido(cartaDoFiltro);
      const valorCompraCarta = Util.getPrecoVariacaoMax(maxBuyNowBase, 2);
      const variacao = this.getVariacaoFiltroHibrido(valorCompraCarta);
      const statusFiltro = this.getStatusFiltroGerenciado(id);
      const motivoEstrategia = this.getMotivoAguardarFluxoSustentadoParaSalvar(id, cartaDoFiltro, statusFiltro);
      const podeSalvar = this.podeSalvarFiltrosAgora() && !motivoEstrategia;
      const motivo = motivoEstrategia || this.getMotivoBloqueioFiltro(id);
      const identidade = this.criarAssinaturaFiltroPadrao(cartaDoFiltro, valorCompraCarta, variacao);
      const limiteCompraMin = this.calcularLimiteCompraMin(cartaDoFiltro);

      if (podeSalvar) {
        TopSniperUtil.salvarFiltroPiloto(this.urlUpdateFiltro, {
          id: id,
          variar: variacao,
          maxBuyNow: valorCompraCarta,
          limite_compra_min: limiteCompraMin || null,
          maskedDefId: [cartaDoFiltro.asset_id],
          rarity: [cartaDoFiltro.rareflag]
        });
      }

      this.filtrosHibridosSelecionados.push({
        id: id,
        slot_id: id,
        slot_rank: this.getSlotRank(id),
        slot_grupo: 'padrao',
        tipo: 'padrao',
        modo: modo,
        nome: (cartaDoFiltro as any).nome,
        resource_id: this.toNumber((cartaDoFiltro as any).resource_id),
        asset_id: this.toNumber((cartaDoFiltro as any).asset_id),
        rareflag: this.toNumber((cartaDoFiltro as any).rareflag),
        id_plataforma: this.normalizarPlataformaConsole((cartaDoFiltro as any).id_plataforma),
        total: this.toNumber((cartaDoFiltro as any).total),
        quantidade_mais_fernando: this.toNumber((cartaDoFiltro as any).quantidade_mais_fernando),
        lucro_unitario: this.toNumber((cartaDoFiltro as any).lucro_unitario),
        lucro: this.toNumber((cartaDoFiltro as any).lucro),
        historico_frequencia: (cartaDoFiltro as any).historico_frequencia || this.getHistoricoFrequenciaCarta(cartaDoFiltro),
        origem_fallback_historico: (cartaDoFiltro as any).origem_fallback_historico || null,
        score_fallback_historico: this.toNumber((cartaDoFiltro as any).score_fallback_historico),
        maxBuyNow: valorCompraCarta,
        limite_compra_min: limiteCompraMin,
        variar: variacao,
        preco: this.toNumber((cartaDoFiltro as any).preco),
        valor_compra: valorCompraCarta,
        filtro_assinatura: identidade.filtro_assinatura,
        assinatura_base: identidade.assinatura_base,
        dados_ea_resumo: identidade.dados_ea_resumo,
        salvamento_bloqueado_estrategia: !!motivoEstrategia,
        status_antes: statusFiltro ? statusFiltro.status : null,
        status_depois: statusFiltro ? statusFiltro.status : null,
        aplicado: podeSalvar,
        motivo: motivo
      });
    }

    private getMotivoAguardarFluxoSustentadoParaSalvar(id: number, cartaDoFiltro: any, statusFiltro: any): any {
      const saude = this.getClassificacaoSaudeFernando();
      if (saude !== 'alto' && saude !== 'muito_alto') {
        return null;
      }

      if (this.cartaTemFluxoSustentado(cartaDoFiltro)) {
        return null;
      }

      if (!statusFiltro || statusFiltro.status !== true) {
        return null;
      }

      const chaveAtual = this.getChaveFiltroEaAtualSlot(id);
      if (!chaveAtual) {
        return null;
      }

      const chaveNova = this.getChaveFiltroEaCarta(cartaDoFiltro);
      if (chaveNova && chaveAtual === chaveNova) {
        return null;
      }

      return 'aguardando_fluxo_sustentado_farm_bom';
    }

    private getMotivoAguardarFluxoSustentadoParaSalvarMulti(statusFiltro: any, historicoFrequencia: any): any {
      const saude = this.getClassificacaoSaudeFernando();
      if (saude !== 'alto' && saude !== 'muito_alto') {
        return null;
      }

      if (historicoFrequencia && historicoFrequencia.fluxo_forte_sustentado) {
        return null;
      }

      if (!statusFiltro || statusFiltro.status !== true) {
        return null;
      }

      return 'aguardando_fluxo_sustentado_farm_bom';
    }

    private getChaveFiltroEaAtualSlot(id: number): string {
      const elEditar = $('#' + id + ' .btn-editar-filtro-pro').first();
      if (!elEditar.length) {
        return null;
      }

      let dados: any = elEditar.data('dados');
      if (typeof dados === 'string') {
        try {
          dados = JSON.parse(dados);
        } catch (e) {
          dados = null;
        }
      }

      const data = dados && dados.data ? dados.data : {};
      const maskedDefId = $.isArray(data.maskedDefId) ? data.maskedDefId : [];
      const rarity = $.isArray(data.rarity) ? data.rarity : [];
      const assetId = maskedDefId.length === 1 ? this.toNumber(maskedDefId[0]) : 0;
      const rareflag = rarity.length === 1 ? this.toNumber(rarity[0]) : 0;

      return assetId && rareflag ? `asset:${assetId}|rare:${rareflag}` : null;
    }

    private calcularMaxBuyNowHibrido(carta: any): number {
      const valorBase = this.getValorMaisFrequente(carta.valor_all, carta.valor);
      const valorMais50 = Math.floor(valorBase * 1.5);
      const precoMenos30 = Math.floor(this.toNumber(carta.preco) * 0.70);

      if (valorMais50 <= 0) return precoMenos30;
      if (precoMenos30 <= 0) return valorMais50;

      return Math.min(valorMais50, precoMenos30);
    }

    private calcularLimiteCompraMin(carta: any): any {
      const menorValor = this.getMenorValorEncontrado(carta && carta.valor_all, carta ? carta.valor : 0);
      if (!menorValor || menorValor <= 0) {
        return null;
      }

      return Util.incrementarValorDeFiltro(Util.tratarValorDeFiltro(menorValor));
    }

    private getMenorValorEncontrado(valorAll: string, valorPadrao: number): number {
      const valorFallback = this.toNumber(valorPadrao);
      if (!valorAll) return valorFallback;

      const valores = valorAll
        .split(',')
        .map((v: string) => parseInt(v.trim()))
        .filter((v: number) => !isNaN(v) && v > 0);

      if (!valores.length) return valorFallback;

      // Math.min.apply estoura a pilha quando valor_all traz muitos valores (GROUP_CONCAT longo).
      let menor = valores[0];
      for (let i = 1; i < valores.length; i++) {
        if (valores[i] < menor) {
          menor = valores[i];
        }
      }

      return menor;
    }

    private getValorMaisFrequente(valorAll: string, valorPadrao: number): number {
      if (!valorAll) return this.toNumber(valorPadrao);

      const valores = valorAll
        .split(',')
        .map((v: string) => parseInt(v.trim()))
        .filter((v: number) => !isNaN(v));

      if (!valores.length) return this.toNumber(valorPadrao);

      const contagem: any = {};

      for (const v of valores) {
        contagem[v] = (contagem[v] || 0) + 1;
      }

      let maisFrequente = valores[0];
      let maior = 0;

      for (const v in contagem) {
        if (contagem[v] > maior) {
          maior = contagem[v];
          maisFrequente = Number(v);
        }
      }

      return maisFrequente || this.toNumber(valorPadrao);
    }

    private getVariacaoFiltroHibrido(valor: any): number {
      const valorNumerico = this.toNumber(valor);

      switch (true) {
        case valorNumerico <= 70000:
          return 10;
        case valorNumerico <= 110000:
          return 5;
        default:
          return 4;
      }
    }

    private renderizarPainelObservadorFernando(): void {
      const analise = this.analiseMercadoFernando;
      if (!analise) return;
      const papel = this.lideranca && this.lideranca.papel ? this.lideranca.papel : 'local';
      const liderIp = this.lideranca && this.lideranca.lider_ip ? this.lideranca.lider_ip : '-';
      const ipServidor = this.lideranca && this.lideranca.ip_servidor ? this.lideranca.ip_servidor : '-';
      const saudeFernando = this.farmSaude && this.farmSaude.fernando ? this.farmSaude.fernando : null;
      const saudeDiego = this.farmSaude && this.farmSaude.diego ? this.farmSaude.diego : null;
      const resumo24h = this.farmSaude && this.farmSaude.resumo_24h ? this.farmSaude.resumo_24h : null;
      const resumoFernando24h = resumo24h && resumo24h.fernando ? resumo24h.fernando : null;
      const inativosManuais = this.estadoInteligencia && this.estadoInteligencia.filtros && this.estadoInteligencia.filtros.inativos_manuais
        ? this.estadoInteligencia.filtros.inativos_manuais.join(', ')
        : '-';
      const protecaoAtiva = this.protecaoMercado && this.protecaoMercado.bloqueia_salvamento;
      const cacheStatus = protecaoAtiva ? 'limpo/ignorado' : 'normal';
      const precoFresco = this.deveForcarPrecoFresco() ? 'forcado' : 'normal';
      const futggSessoes = this.estadoInteligencia && this.estadoInteligencia.futgg ? this.estadoInteligencia.futgg.sessoes_hoje : 0;
      const futggLimite = this.estadoInteligencia && this.estadoInteligencia.futgg ? this.estadoInteligencia.futgg.limite_diario : 24;
      const proximaRevalidacao = this.protecaoMercado && this.protecaoMercado.revalidar_apartir_at ? this.protecaoMercado.revalidar_apartir_at : '-';
      const origemSaude = this.farmSaude && this.farmSaude.origem ? this.farmSaude.origem : '-';
      const cacheExpiraSaude = this.farmSaude && this.farmSaude.cache_expira_at ? this.farmSaude.cache_expira_at : '-';
      const cacheIdadeSaude = this.farmSaude && typeof this.farmSaude.cache_idade_segundos !== 'undefined' ? this.farmSaude.cache_idade_segundos : '-';
      const cacheTtlSaude = this.farmSaude && this.farmSaude.cache_ttl_minutos ? this.farmSaude.cache_ttl_minutos : 5;
      const origemResumo24h = resumo24h && resumo24h.origem ? resumo24h.origem : '-';
      const multiplicadorResumo24h = resumo24h && resumo24h.multiplicador ? resumo24h.multiplicador : 24;
      const controleMix = this.controleMixFiltros || (this.estadoInteligencia && this.estadoInteligencia.controle_slots ? this.estadoInteligencia.controle_slots : (this.estadoInteligencia && this.estadoInteligencia.controle_mix ? this.estadoInteligencia.controle_mix : null));
      const mixRecomendado = controleMix && controleMix.slots_recomendados ? controleMix.slots_recomendados : (controleMix && controleMix.mix_recomendado ? controleMix.mix_recomendado : null);
      const mixAplicado = controleMix && controleMix.slots_aplicados ? controleMix.slots_aplicados : (controleMix && controleMix.mix_aplicado ? controleMix.mix_aplicado : null);
      const recomendacoesMix = controleMix && controleMix.recomendacoes ? controleMix.recomendacoes : null;
      const contextoMix = controleMix && controleMix.contexto ? controleMix.contexto : null;
      const bloqueiosAssinatura = this.estadoInteligencia && this.estadoInteligencia.bloqueios_assinatura ? this.estadoInteligencia.bloqueios_assinatura : (controleMix && controleMix.bloqueios_assinatura ? controleMix.bloqueios_assinatura : null);
      const mixRecomendadoTexto = mixRecomendado ? `${this.formatNumero(mixRecomendado.total)} (${this.formatNumero(mixRecomendado.padrao)}N/${this.formatNumero(mixRecomendado.multi_raridade)}M)` : '-';
      const mixAplicadoTexto = mixAplicado ? `${this.formatNumero(mixAplicado.total)} (${this.formatNumero(mixAplicado.padrao)}N/${this.formatNumero(mixAplicado.multi_raridade)}M)` : '-';
      const recomendacaoOperacaoTexto = recomendacoesMix ? `${this.escapeHtml(recomendacoesMix.contas_simultaneas)} / ${this.formatNumero(recomendacoesMix.velocidade_ms)}ms` : '-';
      const recomendacaoOperacaoMotivo = recomendacoesMix && recomendacoesMix.motivo ? recomendacoesMix.motivo : '-';
      const motivoMix = controleMix && controleMix.motivo ? controleMix.motivo : '-';
      const concentracaoMix = contextoMix && contextoMix.concentracao_mercado ? contextoMix.concentracao_mercado : '-';
      const estrategiaControle = controleMix && controleMix.estrategia_controle ? controleMix.estrategia_controle : 'top_sniper_momento';
      const bloqueiosTexto = bloqueiosAssinatura ? `${this.formatNumero(bloqueiosAssinatura.total_hoje || 0)} / ${this.formatNumero(bloqueiosAssinatura.ativos || 0)}` : '-';
      const bloqueiosMotivos = bloqueiosAssinatura && bloqueiosAssinatura.por_motivo ? JSON.stringify(bloqueiosAssinatura.por_motivo) : '-';
      const normalizacaoSlots = controleMix && $.isArray(controleMix.normalizacao_slots) ? controleMix.normalizacao_slots : [];
      const normalizacaoSlotsTexto = normalizacaoSlots.length
        ? normalizacaoSlots.map((item: any): string => `${item.slot_id}:${item.motivo}`).join(', ')
        : '-';

      const filtrosHibridos = this.filtrosHibridosSelecionados.length
        ? this.filtrosHibridosSelecionados.map((filtro: any): string => {
          const controleSlot = this.getControleFiltroPorSlot(controleMix, filtro.id);
          const assinatura = filtro.filtro_assinatura || (controleSlot ? controleSlot.filtro_assinatura : '-');
          const fluxoForte = this.getTextoFluxoSlot(controleSlot, filtro.historico_frequencia);

          return `
          <tr>
            <td>${this.escapeHtml(filtro.id)}</td>
            <td>${this.escapeHtml(filtro.slot_rank || this.getSlotRank(filtro.id))}</td>
            <td>${this.escapeHtml(filtro.modo)}</td>
            <td>${this.escapeHtml(filtro.nome || '-')}</td>
            <td title="${this.escapeHtml(assinatura)}">${this.escapeHtml(this.encurtarTexto(assinatura))}</td>
            <td>${this.formatNumero(filtro.quantidade_mais_fernando)}</td>
            <td>${this.formatNumero(filtro.lucro_unitario)}</td>
            <td>${this.formatNumero(filtro.lucro)}</td>
            <td>${this.formatNumero(filtro.maxBuyNow)}</td>
            <td>${this.formatNumero(filtro.preco)}</td>
            <td>${this.escapeHtml(fluxoForte)}</td>
            <td>${this.escapeHtml(filtro.aplicado ? 'sim' : 'nao')}</td>
          </tr>
        `;
        }).join('')
        : '<tr><td colspan="12" class="text-muted">Nenhum filtro padrao salvo neste carregamento.</td></tr>';

      const filtrosMultirraridade = this.filtrosTopMultirraridadeSelecionados.length
        ? this.filtrosTopMultirraridadeSelecionados.map((filtro: any): string => {
          const controleSlot = this.getControleFiltroPorSlot(controleMix, filtro.id);
          const assinatura = filtro.filtro_assinatura || (controleSlot ? controleSlot.filtro_assinatura : '-');
          const fluxoForte = this.getTextoFluxoSlot(controleSlot, filtro.historico_frequencia);

          return `
          <tr>
            <td>${this.escapeHtml(filtro.id)}</td>
            <td>${this.escapeHtml(filtro.slot_rank || this.getSlotRank(filtro.id))}</td>
            <td>${this.escapeHtml(filtro.id_filtro_copiar)}</td>
            <td title="${this.escapeHtml(assinatura)}">${this.escapeHtml(this.encurtarTexto(assinatura, 34))}</td>
            <td>${this.formatNumero(filtro.total_registros)}</td>
            <td>${this.formatNumero(filtro.rangeAbs)}</td>
            <td>${this.escapeHtml(fluxoForte)}</td>
            <td>${this.escapeHtml(filtro.aplicado ? 'sim' : 'nao')}</td>
          </tr>
        `;
        }).join('')
        : '<tr><td colspan="8" class="text-muted">Nenhum filtro multi-raridade salvo neste carregamento.</td></tr>';

      const html = `
        <div id="topSniperFernandoObservador" class="mb-4" style="display:block;clear:both;width:100%;max-width:100%;overflow:hidden;">
          <style>
            #topSniperFernandoObservador .fs-observador-box{border:1px solid #d7dde7;border-radius:8px;background:#fff;padding:16px 18px;box-shadow:0 4px 14px rgba(15,23,42,.04);}
            #topSniperFernandoObservador .fs-observador-head{display:flex;align-items:flex-start;justify-content:space-between;gap:12px;margin-bottom:14px;}
            #topSniperFernandoObservador .fs-observador-title{margin:0;color:#172b4d;font-size:16px;font-weight:700;line-height:1.2;}
            #topSniperFernandoObservador .fs-observador-subtitle{font-size:11px;color:#8898aa;margin-top:4px;}
            #topSniperFernandoObservador .fs-observador-badges{display:flex;gap:6px;flex-wrap:wrap;justify-content:flex-end;}
            #topSniperFernandoObservador .fs-metric-grid{display:grid;grid-template-columns:repeat(4,minmax(120px,1fr));gap:10px;margin-bottom:14px;}
            #topSniperFernandoObservador .fs-metric{border:1px solid #edf0f5;border-radius:6px;padding:10px;background:#fbfcfe;min-width:0;}
            #topSniperFernandoObservador .fs-metric-label{display:block;color:#525f7f;font-size:11px;font-weight:700;line-height:1.25;word-break:break-word;}
            #topSniperFernandoObservador .fs-metric-value{display:block;color:#172b4d;font-size:17px;font-weight:700;margin-top:4px;}
            #topSniperFernandoObservador .fs-decision{font-size:12px;color:#525f7f;line-height:1.45;margin-bottom:14px;}
            #topSniperFernandoObservador .fs-tables-grid{display:grid;grid-template-columns:minmax(0,2fr) minmax(260px,1fr);gap:18px;align-items:start;}
            #topSniperFernandoObservador .fs-table-title{font-size:13px;font-weight:700;color:#172b4d;margin:0 0 8px;}
            #topSniperFernandoObservador .table-responsive{width:100%;overflow-x:auto;}
            #topSniperFernandoObservador table{width:100%;font-size:12px;white-space:nowrap;margin-bottom:0;}
            #topSniperFernandoObservador th{font-size:10px;text-transform:uppercase;color:#525f7f;letter-spacing:0;}
            #topSniperFernandoObservador td,#topSniperFernandoObservador th{vertical-align:middle;padding:.45rem .55rem;}
            @media (max-width: 991px){
              #topSniperFernandoObservador .fs-metric-grid{grid-template-columns:repeat(2,minmax(120px,1fr));}
              #topSniperFernandoObservador .fs-tables-grid{grid-template-columns:1fr;}
            }
            @media (max-width: 575px){
              #topSniperFernandoObservador .fs-observador-head{display:block;}
              #topSniperFernandoObservador .fs-observador-badges{justify-content:flex-start;margin-top:8px;}
              #topSniperFernandoObservador .fs-metric-grid{grid-template-columns:1fr;}
            }
          </style>
          <div class="fs-observador-box">
            <div class="fs-observador-head">
              <div>
                <h4 class="fs-observador-title">Observador Fernando</h4>
                <div class="fs-observador-subtitle" title="Snapshot topSniperFernandoSnapshotFrequenciaV1 por resource_id|rareflag|id_plataforma. Saude do farm usa cache backend para evitar leitura repetida da ultima hora.">Fonte da frequencia: ${this.escapeHtml(analise.fonte)} | Plataforma: Console | Saude: ${this.escapeHtml(origemSaude)}</div>
              </div>
              <div class="fs-observador-badges">
                <span class="badge badge-${papel === 'lider' ? 'success' : 'warning'}" title="IP atual: ${this.escapeHtml(ipServidor)} | IP lider: ${this.escapeHtml(liderIp)}">${this.escapeHtml(papel)}</span>
                <span class="badge badge-${analise.modo === 'alta' ? 'success' : 'secondary'}" title="Modo do ciclo da estrategia fernando_hibrido_v1.">Modo: ${this.escapeHtml(analise.modo)}</span>
                <span class="badge badge-${analise.sinal === 'alto' ? 'success' : analise.sinal === 'baixo' ? 'danger' : 'warning'}" title="Sinal do ciclo por frequencia atual.">Sinal: ${this.escapeHtml(analise.sinal)}</span>
                <span class="badge badge-${protecaoAtiva ? 'danger' : 'success'}" title="Protecao/quarentena bloqueia salvamento e reativacao.">Protecao: ${protecaoAtiva ? 'ativa' : 'ok'}</span>
              </div>
            </div>

            <div class="fs-metric-grid">
              <div class="fs-metric" title="Quantidade atual - snapshot anterior, somada nas cartas Console."><span class="fs-metric-label">soma_quantidade_mais</span><span class="fs-metric-value">${this.formatNumero(analise.soma_quantidade_mais)}</span></div>
              <div class="fs-metric" title="Cartas Console com aumento positivo no ciclo."><span class="fs-metric-label">cartas_unicas_com_aumento</span><span class="fs-metric-value">${this.formatNumero(analise.cartas_unicas_com_aumento)}</span></div>
              <div class="fs-metric" title="Cartas novas em relacao ao snapshot anterior."><span class="fs-metric-label">cartas novas no snapshot</span><span class="fs-metric-value">${this.formatNumero(analise.cartas_novas_no_snapshot)}</span></div>
              <div class="fs-metric" title="Tempo desde o ultimo ciclo alto."><span class="fs-metric-label">minutos sem alta</span><span class="fs-metric-value">${analise.minutosSemAlta === null ? '-' : this.formatNumero(analise.minutosSemAlta)}</span></div>
              <div class="fs-metric" title="Lucro previsto sniper da ultima hora para Fernando, com taxa EA de 5%. Origem: ${this.escapeHtml(origemSaude)} | Idade: ${this.escapeHtml(cacheIdadeSaude)}s | TTL: ${this.escapeHtml(cacheTtlSaude)}min | Expira: ${this.escapeHtml(cacheExpiraSaude)}."><span class="fs-metric-label">saude Fernando</span><span class="fs-metric-value">${saudeFernando ? this.escapeHtml(saudeFernando.classificacao) + ' ' + this.formatNumero(saudeFernando.lucro_previsto_sniper) : '-'}</span></div>
              <div class="fs-metric" title="Estrategia decisoria atual. TopSniper momento escolhe filtros; inteligencia controla exposicao, seguranca e fallback."><span class="fs-metric-label">estrategia</span><span class="fs-metric-value">${this.escapeHtml(estrategiaControle)}</span></div>
              <div class="fs-metric" title="Projecao visual baseada no ritmo da ultima hora: lucro 1h x ${this.escapeHtml(multiplicadorResumo24h)}. Nao decide ativacao/desativacao e nao consulta 24h no user_sniper. Origem: ${this.escapeHtml(origemResumo24h)} | Lucro base 1h: ${resumoFernando24h ? this.formatNumero(resumoFernando24h.lucro_base_1h) : '-'}."><span class="fs-metric-label">projecao 24h Fernando</span><span class="fs-metric-value">${resumoFernando24h ? this.formatNumero(resumoFernando24h.lucro_previsto_sniper) : '-'}</span></div>
              <div class="fs-metric" title="Referencia somente leitura do Diego no mesmo periodo, usada apenas para comparacao visual do farm."><span class="fs-metric-label">referencia Diego</span><span class="fs-metric-value">${saudeDiego ? this.escapeHtml(saudeDiego.classificacao) + ' ' + this.formatNumero(saudeDiego.lucro_previsto_sniper) : '-'}</span></div>
              <div class="fs-metric" title="Slots que estavam inativos no carregamento. A inteligencia pode reativar quando houver filtro seguro forte."><span class="fs-metric-label">inativos no inicio</span><span class="fs-metric-value">${this.escapeHtml(inativosManuais)}</span></div>
              <div class="fs-metric" title="Cache geral e preco fresco em protecao/revalidacao."><span class="fs-metric-label">cache/preco</span><span class="fs-metric-value">${this.escapeHtml(cacheStatus)} / ${this.escapeHtml(precoFresco)}</span></div>
              <div class="fs-metric" title="Sessoes FutGG em lote usadas hoje, limite inicial 24/dia e cooldown de 10 minutos."><span class="fs-metric-label">FutGG hoje</span><span class="fs-metric-value">${this.formatNumero(futggSessoes)} / ${this.formatNumero(futggLimite)}</span></div>
              <div class="fs-metric" title="Momento em que a protecao pode ser revalidada."><span class="fs-metric-label">revalidacao</span><span class="fs-metric-value">${this.escapeHtml(proximaRevalidacao)}</span></div>
              <div class="fs-metric" title="Slots recomendados pelo controle: total, filtros normais e multi-raridade."><span class="fs-metric-label">slots recomendados</span><span class="fs-metric-value">${this.escapeHtml(mixRecomendadoTexto)}</span></div>
              <div class="fs-metric" title="Slots realmente ativos nos 6 filtros gerenciados."><span class="fs-metric-label">slots aplicados</span><span class="fs-metric-value">${this.escapeHtml(mixAplicadoTexto)}</span></div>
              <div class="fs-metric" title="Bloqueios de assinatura hoje / ativos. Motivos: ${this.escapeHtml(bloqueiosMotivos)}."><span class="fs-metric-label">bloqueios hoje</span><span class="fs-metric-value">${this.escapeHtml(bloqueiosTexto)}</span></div>
              <div class="fs-metric" title="Recomendacao visual, ainda sem alterar configuracao de contas simultaneas ou velocidade. Motivo: ${this.escapeHtml(recomendacaoOperacaoMotivo)}. 4 contas / 6s fica reservado para fluxo muito forte ou farm acima do esperado."><span class="fs-metric-label">contas / velocidade</span><span class="fs-metric-value">${recomendacaoOperacaoTexto}</span></div>
              <div class="fs-metric" title="Motivo do controle de slots: fluxo_sustentado_top_sniper, fallback_historico_6h, poda_filtro_fraco, aguardando_fluxo_forte_top_sniper, sem_candidato_seguro_financeiro ou protecao."><span class="fs-metric-label">motivo slots</span><span class="fs-metric-value">${this.escapeHtml(motivoMix)}</span></div>
              <div class="fs-metric" title="Ajustes aplicados para impedir buracos na ordem dos slots. Exemplo: slot 03 nao fica ativo se slot 02 estiver inativo."><span class="fs-metric-label">ajustes slots</span><span class="fs-metric-value">${this.escapeHtml(normalizacaoSlotsTexto)}</span></div>
              <div class="fs-metric" title="Concentracao usada na escolha do numero de filtros ativos."><span class="fs-metric-label">concentracao</span><span class="fs-metric-value">${this.escapeHtml(concentracaoMix)}</span></div>
            </div>

            <div class="fs-decision">
              <strong>Motivo:</strong> ${this.escapeHtml(analise.motivo)}
              <br>
              <span>
                Alta: soma >= ${this.configuracoesHibrido.alta.soma_quantidade_mais} ou unicas >= ${this.configuracoesHibrido.alta.cartas_unicas_com_aumento};
                baixa: soma <= ${this.configuracoesHibrido.baixa.soma_quantidade_mais} e unicas <= ${this.configuracoesHibrido.baixa.cartas_unicas_com_aumento};
                muito forte: soma >= ${this.configuracoesHibrido.alta.soma_muito_forte};
                saida da alta: ${this.configuracoesHibrido.baixa.minutos_sem_alta_para_sair} min sem alto e ciclo baixo.
              </span>
            </div>

            <div class="fs-tables-grid">
              <div>
                <h5 class="fs-table-title">Filtros padrao escolhidos</h5>
                <div class="table-responsive">
                  <table class="table table-sm">
                    <thead>
                      <tr>
                        <th>Filtro</th>
                        <th>Rank</th>
                        <th>Modo</th>
                        <th>Carta</th>
                        <th>Assinatura</th>
                        <th>Qtd+</th>
                        <th>Lucro un.</th>
                        <th>Lucro</th>
                        <th>Buy</th>
                        <th>Preco</th>
                        <th>Fluxo</th>
                        <th>Aplicou</th>
                      </tr>
                    </thead>
                    <tbody>${filtrosHibridos}</tbody>
                  </table>
                </div>
              </div>
              <div>
                <h5 class="fs-table-title">Multi-raridade</h5>
                <div class="table-responsive">
                  <table class="table table-sm">
                    <thead>
                      <tr>
                        <th>Destino</th>
                        <th>Rank</th>
                        <th>Origem</th>
                        <th>Assinatura</th>
                        <th>Total</th>
                        <th>Range</th>
                        <th>Fluxo</th>
                        <th>Aplicou</th>
                      </tr>
                    </thead>
                    <tbody>${filtrosMultirraridade}</tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      `;

      const $painelAtual = $('#topSniperFernandoObservador');
      if ($painelAtual.length) {
        $painelAtual.replaceWith(html);
        return;
      }

      const $wrapper = $('#dataTableTopSnipers_wrapper');
      if ($wrapper.length) {
        $wrapper.before(html);
        return;
      }

      const $cardDadosSnipers = $('#cardDadosSnipers');
      if ($cardDadosSnipers.length) {
        $cardDadosSnipers.prepend(html);
        return;
      }

      const $tabela = $('#dataTableTopSnipers');
      if ($tabela.length) {
        $tabela.before(html);
      }
    }

    private getControleFiltroPorSlot(controleMix: any, id: any): any {
      const slotId = this.toNumber(id);
      if (!controleMix || !controleMix.filtros_por_slot || !slotId) {
        return null;
      }

      return controleMix.filtros_por_slot[slotId] || controleMix.filtros_por_slot[String(slotId)] || null;
    }

    private getTextoFluxoSlot(controleSlot: any, historico: any): string {
      const nivel = this.toNumber(
        controleSlot && controleSlot.nivel_abertura_slot
          ? controleSlot.nivel_abertura_slot
          : (historico && historico.nivel_abertura_slot ? historico.nivel_abertura_slot : 0)
      );
      const confirmado = controleSlot && controleSlot.fluxo_confirmado_abrir_slot
        ? true
        : !!(historico && historico.fluxo_confirmado_abrir_slot);
      if (confirmado) {
        return nivel >= 4 ? 'abrir4' : 'abrir3';
      }

      const forte = controleSlot && controleSlot.fluxo_forte_sustentado
        ? true
        : !!(historico && historico.fluxo_forte_sustentado);

      return forte ? 'forte' : 'nao';
    }

    private encurtarTexto(valor: any, limite: number = 42): string {
      const texto = String(valor === null || typeof valor === 'undefined' ? '' : valor);
      if (texto.length <= limite) {
        return texto;
      }

      return texto.substr(0, limite - 3) + '...';
    }

    private escapeHtml(valor: any): string {
      return String(valor === null || typeof valor === 'undefined' ? '' : valor)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }

    private formatNumero(valor: any): string {
      const numero = this.toNumber(valor);
      return numero.toLocaleString('pt-BR');
    }


    private iniciandoAnaliseTopFiltros(): void {
      const url = `${window.location.origin}/admin/top-filtros-json`;
      console.log("URL APP", url)

      // $.ajax direto (em vez de Ajax.get) somente para poder limitar o tempo:
      // uma requisicao pendurada segurava o JSON dos filtros em memoria ate a navegacao.
      $.ajax({
        url: url,
        type: 'GET',
        timeout: this.timeoutRequisicaoTopFiltros,
        success: (dados: any): void => {
          this.tratarDadosTopFiltros(dados && dados.topFiltros ? dados.topFiltros : [])
        },
        // Falha de rede nao e o mesmo que "nenhum filtro": nao mexe nos slots multi-raridade.
        error: (jqXHR: any, status: any): void => {
          console.warn('TOP SNIPER: falha ao carregar top-filtros-json', status);
        }
      });
    }

    private async tratarDadosTopFiltros(topFiltros: IObjetoTopFiltros[] = []): Promise<void> {
      TopSniperUtil.logTopSniper("DADOS TOP FILTROS", topFiltros);
      this.filtrosTopMultirraridadeSelecionados = [];

      if (!topFiltros.length) {
        console.warn("Nenhum filtro encontrado.");
        await this.aplicarControleMixInteligencia();
        this.renderizarPainelObservadorFernando();
        return;
      }

      let melhoresFiltros = this.getMelhoresFiltrosDeMomento(topFiltros, 2, {
        minRegistros: 2,
        minPriceFloor: 10000,
        maxPriceCeiling: this.configuracoes.piloto.principal.valor_caixa_maximo,
        minRangeAbs: 15000,
        exigirMultirraridade: true,
        suspiciousIds: new Set([])
      });

      this.registrarHistoricoCandidatosMulti(melhoresFiltros);
      if (this.deveUsarFallbackHistorico()) {
        const historicoMulti = this.getFiltrosHistoricoFallbackMulti();
        if (historicoMulti.length) {
          melhoresFiltros = historicoMulti;
        }
      }

      TopSniperUtil.logTopSniper("MELHORES FILTROS DO MOMENTO", melhoresFiltros);

      if (!melhoresFiltros.length) {
        console.warn("Nenhum filtro qualificado encontrado.");
        await this.aplicarControleMixInteligencia();
        this.renderizarPainelObservadorFernando();
        return;
      }

      // Salvar os melhores filtros (verifica se existem filtros suficientes)
      const filtrosPiloto = [
        { id: this.configuracoes.filtros.id_filtro_piloto_top_filtros_A, filtro: melhoresFiltros[0] || null },
        { id: this.configuracoes.filtros.id_filtro_piloto_top_filtros_B, filtro: melhoresFiltros[1] || null }
      ];


      filtrosPiloto.forEach((f) => {
        if (f.filtro) {
          const identidade = this.criarAssinaturaFiltroMulti(f.filtro);
          const statusFiltro = this.getStatusFiltroGerenciado(f.id);
          const historicoFrequencia = this.getHistoricoFrequenciaTopFiltro(f.filtro);
          const motivoEstrategia = this.getMotivoAguardarFluxoSustentadoParaSalvarMulti(statusFiltro, historicoFrequencia);
          const podeSalvar = this.podeSalvarFiltrosAgora() && !motivoEstrategia;
          console.log(`💸 Substituir filtro ${f.id} pelo filtro de ID ${f.filtro.id_filtro} com preço médio de ${f.filtro.avg}`);
          if (podeSalvar) {
            TopSniperUtil.salvarFiltroPiloto(this.urlUpdateFiltro, {
              id: f.id,
              id_filtro_copiar: f.filtro.id_filtro,
            });
          }

          this.filtrosTopMultirraridadeSelecionados.push({
            id: f.id,
            slot_id: f.id,
            slot_rank: this.getSlotRank(f.id),
            slot_grupo: 'multi_raridade',
            tipo: 'multi_raridade',
            id_filtro_copiar: f.filtro.id_filtro,
            total_registros: f.filtro.total_registros,
            rangeAbs: f.filtro.rangeAbs,
            menor_valor_observado: this.toNumber(f.filtro.menor_valor_observado || f.filtro.menor_valor || f.filtro.min),
            min: this.toNumber(f.filtro.min || f.filtro.menor_valor),
            max: this.toNumber(f.filtro.max || f.filtro.maior_valor),
            historico_frequencia: historicoFrequencia,
            origem_fallback_historico: f.filtro.origem_fallback_historico || null,
            score_fallback_historico: this.toNumber(f.filtro.score_fallback_historico),
            filtro_assinatura: identidade.filtro_assinatura,
            assinatura_base: identidade.assinatura_base,
            dados_ea_hash: identidade.dados_ea_hash,
            dados_ea_resumo: identidade.dados_ea_resumo,
            status_antes: statusFiltro ? statusFiltro.status : null,
            status_depois: statusFiltro ? statusFiltro.status : null,
            aplicado: podeSalvar,
            motivo: motivoEstrategia || this.getMotivoBloqueioFiltro(f.id),
            salvamento_bloqueado_estrategia: !!motivoEstrategia
          });
        }
      });

      this.registrarDecisaoInteligencia('multi_raridade');
      await this.aplicarControleMixInteligencia();
      this.renderizarPainelObservadorFernando();
    }

    private getCartasInteresseFiltrosPrincipais(topCartasMomento: ICartaTopSniper[] = this.topCartasMomento, quantidadeAmais: number = this.configuracoes.piloto.principal.quantidade_indicativa_que_a_carta_esta_caindo): ICartaTopSniper[] {
      return topCartasMomento.filter((ele: ICartaTopSniper) => {
        let naoConsiderarCartasDeValorAltoComPoucaQuantidade = !(ele.valor >= this.configuracoes.piloto.principal.desconsiderar_poucas_cartas_acima_de
          && ele.total < this.configuracoes.piloto.principal.quantidade_considero_poucas_cartas);

        return ele.quantidade_mais >= quantidadeAmais
          && ele.rareflag >= this.configuracoes.piloto.principal.raridade_minima_piloto_principal
          && ele.lucro_unitario && ele.lucro_unitario >= this.configuracoes.piloto.principal.lucro_unitario_minimo
          && ele.valor >= this.configuracoes.piloto.principal.preco_compra_carta_acima_de
          && ele.valor <= this.configuracoes.piloto.principal.valor_caixa_maximo
          && naoConsiderarCartasDeValorAltoComPoucaQuantidade;
      });
    }

    private getCartasInteresseFiltrosPrincipaisSobra(topCartasMomento: ICartaTopSniper[] = this.topCartasMomento): ICartaTopSniper[] {
      return topCartasMomento.filter((ele: ICartaTopSniper) => {
        return ele.quantidade_mais < this.configuracoes.piloto.principal.quantidade_indicativa_que_a_carta_esta_caindo
          && ele.total >= this.configuracoes.piloto.principal.quantidade_considero_poucas_cartas
          && ele.rareflag >= this.configuracoes.piloto.principal.raridade_minima_piloto_principal
          && ele.lucro_unitario && ele.lucro_unitario >= this.configuracoes.piloto.principal.lucro_unitario_minimo
          && ele.valor >= this.configuracoes.piloto.principal.preco_compra_carta_acima_de
          && ele.valor <= this.configuracoes.piloto.principal.valor_caixa_maximo;
      });
    }

    public async processarTopCartasPilotoPrincipalPorRaridade(cartasEspeciaisPilotoPlus: ICartaTopSniper[], cartasEspeciaisPilotoSobra: ICartaTopSniper[]) {
      if (cartasEspeciaisPilotoPlus.length) {
        TopSniperFernando.salvarFiltroFernando(this.configuracoes.filtros.id_filtro_especial_piloto_a, cartasEspeciaisPilotoPlus[0], cartasEspeciaisPilotoPlus,
          this.configuracoes.piloto.principal.lucro_unitario_minimo_cartas_relacionadas,
          this.configuracoes.piloto.principal.total_cartas_relacionadas_incluir_no_filtro,
          this.urlUpdateFiltro);

        if (cartasEspeciaisPilotoPlus.length <= 1 && cartasEspeciaisPilotoSobra.length) {
          cartasEspeciaisPilotoPlus = cartasEspeciaisPilotoPlus.concat(cartasEspeciaisPilotoSobra);
        }

        if (cartasEspeciaisPilotoPlus.length > 1) {
          TopSniperFernando.salvarFiltroFernando(this.configuracoes.filtros.id_filtro_especial_piloto_b, cartasEspeciaisPilotoPlus[1], cartasEspeciaisPilotoPlus,
            this.configuracoes.piloto.principal.lucro_unitario_minimo_cartas_relacionadas,
            this.configuracoes.piloto.principal.total_cartas_relacionadas_incluir_no_filtro,
            this.urlUpdateFiltro);
        }

        if (cartasEspeciaisPilotoPlus.length <= 2 && cartasEspeciaisPilotoSobra.length) {
          cartasEspeciaisPilotoPlus = cartasEspeciaisPilotoPlus.concat(cartasEspeciaisPilotoSobra);
        }

        if (cartasEspeciaisPilotoPlus.length > 2) {
          TopSniperFernando.salvarFiltroFernando(this.configuracoes.filtros.id_filtro_especial_piloto_c, cartasEspeciaisPilotoPlus[2], cartasEspeciaisPilotoPlus,
            this.configuracoes.piloto.principal.lucro_unitario_minimo_cartas_relacionadas,
            this.configuracoes.piloto.principal.total_cartas_relacionadas_incluir_no_filtro,
            this.urlUpdateFiltro);
        }

        if (cartasEspeciaisPilotoPlus.length > 3) {
          TopSniperFernando.salvarFiltroFernando(this.configuracoes.filtros.id_filtro_especial_piloto_d, cartasEspeciaisPilotoPlus[3], cartasEspeciaisPilotoPlus,
            this.configuracoes.piloto.principal.lucro_unitario_minimo_cartas_relacionadas,
            this.configuracoes.piloto.principal.total_cartas_relacionadas_incluir_no_filtro,
            this.urlUpdateFiltro);
        }
      }

      TopSniperUtil.logTopSniper("PILOTO PRINCIPAL RARIDADES FINAL", cartasEspeciaisPilotoPlus);

      // this.armazenarCartasPilotoPrincipal();
      // this.verificarESalvarCartasPrincipaisAcumuladas();
    }

    public async processarTopCartasPilotoPrincipalPorQualidade(cartasEspeciaisPilotoPlus: ICartaTopSniper[], cartasEspeciaisPilotoSobra: ICartaTopSniper[]) {
      if (cartasEspeciaisPilotoPlus.length) {
        TopSniperFernando.salvarFiltroFernandoPorQualidade(this.configuracoes.filtros.id_filtro_especial_piloto_a, cartasEspeciaisPilotoPlus[0], cartasEspeciaisPilotoPlus,
          this.configuracoes.piloto.principal.lucro_unitario_minimo_cartas_relacionadas,
          this.configuracoes.piloto.principal.total_cartas_relacionadas_incluir_no_filtro,
          this.urlUpdateFiltro);

        if (cartasEspeciaisPilotoPlus.length <= 1 && cartasEspeciaisPilotoSobra.length) {
          cartasEspeciaisPilotoPlus = cartasEspeciaisPilotoPlus.concat(cartasEspeciaisPilotoSobra);
        }

        if (cartasEspeciaisPilotoPlus.length > 1) {
          TopSniperFernando.salvarFiltroFernandoPorQualidade(this.configuracoes.filtros.id_filtro_especial_piloto_b, cartasEspeciaisPilotoPlus[1], cartasEspeciaisPilotoPlus,
            this.configuracoes.piloto.principal.lucro_unitario_minimo_cartas_relacionadas,
            this.configuracoes.piloto.principal.total_cartas_relacionadas_incluir_no_filtro,
            this.urlUpdateFiltro);
        }

        if (cartasEspeciaisPilotoPlus.length <= 2 && cartasEspeciaisPilotoSobra.length) {
          cartasEspeciaisPilotoPlus = cartasEspeciaisPilotoPlus.concat(cartasEspeciaisPilotoSobra);
        }

        if (cartasEspeciaisPilotoPlus.length > 2) {
          TopSniperFernando.salvarFiltroFernandoPorQualidade(this.configuracoes.filtros.id_filtro_especial_piloto_c, cartasEspeciaisPilotoPlus[2], cartasEspeciaisPilotoPlus,
            this.configuracoes.piloto.principal.lucro_unitario_minimo_cartas_relacionadas,
            this.configuracoes.piloto.principal.total_cartas_relacionadas_incluir_no_filtro,
            this.urlUpdateFiltro);
        }

        if (cartasEspeciaisPilotoPlus.length > 3) {
          TopSniperFernando.salvarFiltroFernandoPorQualidade(this.configuracoes.filtros.id_filtro_especial_piloto_d, cartasEspeciaisPilotoPlus[3], cartasEspeciaisPilotoPlus,
            this.configuracoes.piloto.principal.lucro_unitario_minimo_cartas_relacionadas,
            this.configuracoes.piloto.principal.total_cartas_relacionadas_incluir_no_filtro,
            this.urlUpdateFiltro);
        }
      }

      TopSniperUtil.logTopSniper("PILOTO PRINCIPAL QUALIDADES FINAL", { principal: cartasEspeciaisPilotoPlus, sobra: cartasEspeciaisPilotoSobra });

      // this.armazenarCartasPilotoPrincipal();
      // this.verificarESalvarCartasPrincipaisAcumuladas();
    }

    public async metodoTopCartasPilotoPrincipal() {
      let cartasEspeciaisPilotoPlus: ICartaTopSniper[] = this.getCartasInteresseFiltrosPrincipais()
      let cartasEspeciaisPilotoSobra: ICartaTopSniper[] = this.getCartasInteresseFiltrosPrincipaisSobra()
      let cartasQualidadeEspeciaisPilotoPlus: ICartaTopSniper[] = []
      let cartasQualidadeEspeciaisPilotoSobra: ICartaTopSniper[] = []

      TopSniperUtil.logTopSniper("PILOTO PRINCIPAL", cartasEspeciaisPilotoPlus);
      TopSniperUtil.logTopSniper("PILOTO SOBRA", cartasEspeciaisPilotoSobra);

      if (this.configuracoes.usar_filtro_qualidade) {
        cartasQualidadeEspeciaisPilotoPlus = await TopSniperUtil.filtrarCartasQualidadeEspecialCompativelFiltro(cartasEspeciaisPilotoPlus)
        cartasQualidadeEspeciaisPilotoSobra = await TopSniperUtil.filtrarCartasQualidadeEspecialCompativelFiltro(cartasEspeciaisPilotoSobra)
      }

      TopSniperUtil.logTopSniper("PILOTO QUALIDADE PRINCIPAL", { filtradas: cartasQualidadeEspeciaisPilotoPlus.length, originais: cartasEspeciaisPilotoPlus.length, cartas: cartasQualidadeEspeciaisPilotoPlus });
      TopSniperUtil.logTopSniper("PILOTO QUALIDADE SOBRA", { filtradas: cartasQualidadeEspeciaisPilotoSobra.length, originais: cartasEspeciaisPilotoSobra.length, cartas: cartasQualidadeEspeciaisPilotoSobra });

      if (this.configuracoes.usar_filtro_qualidade) {
        this.processarTopCartasPilotoPrincipalPorQualidade(cartasQualidadeEspeciaisPilotoPlus, cartasQualidadeEspeciaisPilotoSobra)
      } else {
        this.processarTopCartasPilotoPrincipalPorRaridade(cartasEspeciaisPilotoPlus, cartasEspeciaisPilotoSobra)
      }
    }

    private getCartasInteresseFiltrosIniciais(topCartasMomento: ICartaTopSniper[] = this.topCartasMomento, quantidadeAmais: number = 1): ICartaTopSniper[] {
      return topCartasMomento.filter((ele: any) => {
        return ele.quantidade_mais >= quantidadeAmais
          && ele.lucro_unitario && ele.lucro_unitario >= this.configuracoes.piloto.inicial.lucro_unitario_minimo
          && ele.valor >= this.configuracoes.piloto.inicial.preco_compra_carta_acima_de
          && ele.valor <= this.configuracoes.piloto.inicial.valor_caixa_maximo;
      });
    }

    private metodoTopCartasOuroPilotoSecundarioInicial() {
      let cartasOuroPiloto = this.getCartasInteresseFiltrosIniciais()
      TopSniperUtil.logTopSniper("PILOTO INICIAL", cartasOuroPiloto);

      // salvando até 4 filtros
      if (cartasOuroPiloto.length) {
        TopSniperFernando.salvarFiltroFernando(this.configuracoes.filtros.id_filtro_piloto_inicial_A, cartasOuroPiloto[0], cartasOuroPiloto,
          this.configuracoes.piloto.inicial.lucro_unitario_minimo_cartas_relacionadas,
          this.configuracoes.piloto.inicial.total_cartas_relacionadas_incluir_no_filtro,
          this.urlUpdateFiltro
        );

        // if (cartasOuroPiloto.length > 1) {
        //   TopSniperFernando.salvarFiltroFernando(this.configuracoes.filtros.id_filtro_piloto_inicial_B, cartasOuroPiloto[1], cartasOuroPiloto,
        //     this.configuracoes.piloto.inicial.lucro_unitario_minimo_cartas_relacionadas,
        //     this.configuracoes.piloto.inicial.total_cartas_relacionadas_incluir_no_filtro,
        //     this.urlUpdateFiltro
        //   );
        // }

        // if (cartasOuroPiloto.length > 2) {
        //   TopSniperFernando.salvarFiltroFernando(this.configuracoes.filtros.id_filtro_piloto_inicial_C, cartasOuroPiloto[2], cartasOuroPiloto, this.configuracoes.piloto.inicial.lucro_unitario_minimo_cartas_relacionadas, this.urlUpdateFiltro);
        // }

        // if (cartasOuroPiloto.length > 3) {
        //   TopSniperFernando.salvarFiltroFernando(this.configuracoes.filtros.id_filtro_piloto_inicial_D, cartasOuroPiloto[3], cartasOuroPiloto, this.configuracoes.piloto.inicial.lucro_unitario_minimo_cartas_relacionadas, this.urlUpdateFiltro);
        // }
      }

      TopSniperUtil.logTopSniper("PILOTO INICIAL FINAL", cartasOuroPiloto);
    }

    private armazenarCartasPilotoPrincipal(): void {
      let cartasArmazenadas = this.getCartasArmazenadas();

      // armazenando full das duas de mais lucro
      if (this.topCartasMomento.length) {
        cartasArmazenadas.push(this.compactarCartaHistoricoFallback(this.topCartasMomento[0]) as ICartaTopSniper);
        if (this.topCartasMomento.length > 1) {
          cartasArmazenadas.push(this.compactarCartaHistoricoFallback(this.topCartasMomento[1]) as ICartaTopSniper);
        }
      }

      this.setStorageJsonSeguro(this.keyStorageCartasArmazenadas, cartasArmazenadas.slice(-120));
    }

    private getCartasArmazenadas(key: string = this.keyStorageCartasArmazenadas): ICartaTopSniper[] {
      return JSON.parse(localStorage.getItem(key) || '[]') as ICartaTopSniper[];
    }

    public estaNaHoraDeSalvarFiltroFull(agora: number): boolean {
      const ultimaVezSalvo = localStorage.getItem(this.keyStorageUltimaVezSalvoFiltroFull);
      const intervaloEmMilissegundos = this.intervaloEmMinutosStorageTempoAtualizacaoFiltroFull * 60 * 1000;

      return !ultimaVezSalvo || (agora - parseInt(ultimaVezSalvo, 10)) >= intervaloEmMilissegundos;
    }

    private verificarESalvarCartasPrincipaisAcumuladas(): void {
      const agora = Date.now();
      if (this.estaNaHoraDeSalvarFiltroFull(agora)) {
        this.salvarFiltroMaisFrequentePrincipal();
        this.setStorageValorSeguro(this.keyStorageUltimaVezSalvoFiltroFull, agora.toString());
      }
    }

    private encontrarCartaMaisFrequente(cartasArmazenadas: ICartaTopSniper[]): ICartaTopSniper {
      if (cartasArmazenadas.length === 0) {
        return null;
      }

      let contagemCartas: { [key: string]: number } = {};

      cartasArmazenadas.forEach((carta: any) => {
        if (contagemCartas[carta.resource_id]) {
          contagemCartas[carta.resource_id]++;
        } else {
          contagemCartas[carta.resource_id] = 1;
        }
      });

      let resourceIdMaisFrequente = Object.keys(contagemCartas).reduce((a, b) => contagemCartas[a] > contagemCartas[b] ? a : b);
      return (cartasArmazenadas as any).find((carta: ICartaTopSniper) => carta.resource_id.toString() === resourceIdMaisFrequente.toString());
    }

    private topCartasMaisFrequentes(cartasArmazenadas: ICartaTopSniper[]): ICartaTopSniper[] {
      if (cartasArmazenadas.length === 0) {
        return [];
      }

      let contagemCartas: { [key: string]: number } = {};

      // Contar a frequência de cada carta
      cartasArmazenadas.forEach((carta: ICartaTopSniper) => {
        if (contagemCartas[carta.resource_id]) {
          contagemCartas[carta.resource_id]++;
        } else {
          contagemCartas[carta.resource_id] = 1;
        }
      });

      // Ordenar as cartas pela frequência em ordem decrescente
      let cartasOrdenadas = Object.keys(contagemCartas)
        .sort((a, b) => contagemCartas[b] - contagemCartas[a])
        .slice(0, 6); // Selecionar as 6 cartas mais frequentes

      // Encontrar as cartas correspondentes aos IDs mais frequentes
      let cartasMaisFrequentes = cartasOrdenadas.map(resourceId =>
        (cartasArmazenadas as any).find((carta: ICartaTopSniper) => carta.resource_id.toString() === resourceId.toString())
      );

      return cartasMaisFrequentes.filter(carta => carta !== undefined) as ICartaTopSniper[];
    }

    private salvarFiltroMaisFrequentePrincipal(): void {
      let cartasArmazenadas = this.getCartasArmazenadas();
      if (cartasArmazenadas.length === 0) return;


      let todasCartaMaisFrequente: ICartaTopSniper = this.encontrarCartaMaisFrequente(cartasArmazenadas);
      let topCartaMaisFrequente: ICartaTopSniper[] = this.topCartasMaisFrequentes(cartasArmazenadas);

      let cartasPilotoInicialMaisFrequentes: ICartaTopSniper[] = this.getCartasInteresseFiltrosIniciais(topCartaMaisFrequente, 0)
      let cartasPilotoPrincipalMaisFrequentes: ICartaTopSniper[] = this.getCartasInteresseFiltrosPrincipais(topCartaMaisFrequente, 0)
      // da um merge nas duas listas cartasPilotoInicialMaisFrequentes e cartasPilotoPrincipalMaisFrequentes
      let topCartaMaisFrequentePilotoPrincipalEInicial = cartasPilotoInicialMaisFrequentes.concat(cartasPilotoPrincipalMaisFrequentes);

      // let topCartaMaisFrequenteAgrupadas = this.agruparPorRaridade(topCartaMaisFrequentePilotoPrincipalEInicial);

      console.log(`💎 SALVAR: CARTA FREQUENTE EM ${this.intervaloEmMinutosStorageTempoAtualizacaoFiltroFull}`);
      TopSniperUtil.logTopSniper('cartaMaisFrequente', todasCartaMaisFrequente);
      TopSniperUtil.logTopSniper('topCartaMaisFrequente', topCartaMaisFrequente);

      TopSniperUtil.logTopSniper('topCartaMaisFrequentePilotoPrincipalEInicial', topCartaMaisFrequentePilotoPrincipalEInicial);

      TopSniperUtil.logTopSniper('cartasPilotoInicialMaisFrequentes', cartasPilotoInicialMaisFrequentes);
      TopSniperUtil.logTopSniper('cartasPilotoPrincipalMaisFrequentes', cartasPilotoPrincipalMaisFrequentes);

      // console.log('topCartaMaisFrequenteAgrupadas', topCartaMaisFrequenteAgrupadas);

      if (topCartaMaisFrequentePilotoPrincipalEInicial.length) {
        TopSniperFernando.salvarFiltroFernando(this.configuracoes.filtros.id_filtro_piloto_full_A, topCartaMaisFrequentePilotoPrincipalEInicial[0], topCartaMaisFrequentePilotoPrincipalEInicial,
          this.configuracoes.piloto.full.lucro_unitario_minimo_cartas_relacionadas,
          this.configuracoes.piloto.full.total_cartas_relacionadas_incluir_no_filtro, this.urlUpdateFiltro
        );
        if (topCartaMaisFrequentePilotoPrincipalEInicial.length > 1) {
          TopSniperFernando.salvarFiltroFernando(this.configuracoes.filtros.id_filtro_piloto_full_B, topCartaMaisFrequentePilotoPrincipalEInicial[1], topCartaMaisFrequentePilotoPrincipalEInicial,
            this.configuracoes.piloto.full.lucro_unitario_minimo_cartas_relacionadas,
            this.configuracoes.piloto.full.total_cartas_relacionadas_incluir_no_filtro,
            this.urlUpdateFiltro
          );
        }
      }
    }


    private filtroTopEhMultirraridadeValido(filtro: any): boolean {
      const dadosFiltro = this.getDadosFiltroTop(filtro);

      if (!dadosFiltro) {
        return false;
      }

      return this.validarDadosFiltroComoMultirraridade(dadosFiltro);
    }

    private getDadosFiltroTop(filtro: any): any {
      if (!filtro) return null;

      return filtro.dados || filtro.data || null;
    }

    private criarResumoDadosFiltroTop(dados: any): any {
      if (!dados) {
        return {
          rarity_total: 0,
          maskedDefId_vazio: true
        };
      }

      if (typeof dados === 'string') {
        const texto = dados.trim();
        if (!texto) {
          return {
            rarity_total: 0,
            maskedDefId_vazio: true
          };
        }

        if (texto[0] === '{' || texto[0] === '[') {
          try {
            return this.criarResumoDadosFiltroTop(JSON.parse(texto));
          } catch (e) {
            return {
              rarity_total: this.getSerializedArrayLength(texto, 'rarity'),
              maskedDefId_vazio: texto.indexOf('maskedDefId') < 0,
              formato: 'serializado'
            };
          }
        }

        return {
          rarity_total: this.getSerializedArrayLength(texto, 'rarity'),
          maskedDefId_vazio: texto.indexOf('maskedDefId') < 0,
          formato: 'serializado'
        };
      }

      const dadosNormalizados = dados.data ? dados.data : dados;
      const rarity = dadosNormalizados.rarity || dadosNormalizados.rarityIds;
      const raridades = $.isArray(rarity)
        ? rarity.filter((item: any): boolean => item !== null && typeof item !== 'undefined' && item !== '')
        : (typeof rarity === 'string' && rarity.indexOf(',') >= 0
          ? rarity.split(',').map((item: string): string => item.trim()).filter((item: string): boolean => !!item)
          : (rarity ? [rarity] : []));
      const temCampoJogador = dadosNormalizados.hasOwnProperty('maskedDefId');
      const maskedDefId = dadosNormalizados.maskedDefId;
      const maskedDefIdVazio = !temCampoJogador
        || maskedDefId === null
        || typeof maskedDefId === 'undefined'
        || maskedDefId === ''
        || ($.isArray(maskedDefId) && maskedDefId.length === 0);

      return {
        rarity_total: raridades.length,
        rarity: raridades.slice(0, 8),
        maskedDefId_vazio: maskedDefIdVazio,
        quality: dadosNormalizados.quality || null,
        league: dadosNormalizados.league || dadosNormalizados.leagueId || null,
        nation: dadosNormalizados.nation || dadosNormalizados.nationId || null,
        team: dadosNormalizados.team || dadosNormalizados.teamId || null
      };
    }

    private validarDadosFiltroComoMultirraridade(dados: any): boolean {
      if (!dados) return false;

      if (typeof dados === 'string') {
        const texto = dados.trim();
        if (!texto) return false;

        if (texto[0] === '{' || texto[0] === '[') {
          try {
            return this.validarDadosFiltroComoMultirraridade(JSON.parse(texto));
          } catch (e) {
            return false;
          }
        }

        return this.validarDadosFiltroSerializadoComoMultirraridade(texto);
      }

      const dadosNormalizados = dados.data ? dados.data : dados;
      const rarity = dadosNormalizados.rarity || dadosNormalizados.rarityIds;
      const raridades = $.isArray(rarity)
        ? rarity.filter((item: any) => item !== null && typeof item !== 'undefined' && item !== '')
        : (typeof rarity === 'string' && rarity.indexOf(',') >= 0
          ? rarity.split(',').map((item: string) => item.trim()).filter((item: string) => !!item)
          : (rarity ? [rarity] : []));
      const temCampoJogador = dadosNormalizados.hasOwnProperty('maskedDefId');
      const maskedDefId = dadosNormalizados.maskedDefId;
      const maskedDefIdVazio = !temCampoJogador
        || maskedDefId === null
        || typeof maskedDefId === 'undefined'
        || maskedDefId === ''
        || ($.isArray(maskedDefId) && maskedDefId.length === 0);

      return raridades.length > 1 && maskedDefIdVazio;
    }

    private validarDadosFiltroSerializadoComoMultirraridade(serialized: string): boolean {
      const totalRaridades = this.getSerializedArrayLength(serialized, 'rarity');

      if (totalRaridades <= 1) {
        return false;
      }

      if (!this.serializedFieldExists(serialized, 'maskedDefId')) {
        return true;
      }

      if (this.serializedFieldIsNull(serialized, 'maskedDefId')) {
        return true;
      }

      return this.getSerializedArrayLength(serialized, 'maskedDefId') === 0;
    }

    /**
     * O historico multi era relido do localStorage em 4 pontos do mesmo ciclo, e cada registro
     * carrega o campo 'dados' serializado inteiro do filtro. Uma leitura por ciclo basta.
     */
    private getHistoricoCandidatosMultiStorage(): any[] {
      if (this.historicoCandidatosMultiStorage === null) {
        const dados = this.getStorageJson(this.keyStorageHistoricoCandidatosMulti, []);
        this.historicoCandidatosMultiStorage = $.isArray(dados) ? dados : [];
      }

      return this.historicoCandidatosMultiStorage;
    }

    private registrarHistoricoCandidatosMulti(filtros: any[]): void {
      const agora = Date.now();
      const limiteAntigo = agora - (24 * 60 * 60 * 1000);
      const registros = this.getHistoricoCandidatosMultiStorage();

      (filtros || []).forEach((filtro: any) => {
        registros.push({
          horario: agora,
          chave: this.getChaveTopFiltro(filtro),
          filtro: this.compactarFiltroMultiHistoricoFallback(filtro),
          total_registros: this.toNumber(filtro.total_registros),
          rangeAbs: this.toNumber(filtro.rangeAbs),
          total_jogadores_distintos: this.toNumber(filtro.total_jogadores_distintos),
          resource_ids: filtro.resource_ids || null
        });
      });

      const registrosAtualizados = registros
        .filter((item: any): boolean => this.toNumber(item.horario) >= limiteAntigo)
        .slice(-160);

      this.historicoCandidatosMultiStorage = registrosAtualizados;
      this.setStorageJsonSeguro(this.keyStorageHistoricoCandidatosMulti, registrosAtualizados);
    }

    private getFiltrosHistoricoFallbackMulti(): any[] {
      const agora = Date.now();
      const registros = this.getHistoricoCandidatosMultiStorage();
      const porChave: any = {};

      ($.isArray(registros) ? registros : []).forEach((item: any) => {
        const idadeHoras = (agora - this.toNumber(item.horario)) / (60 * 60 * 1000);
        if (idadeHoras < 0 || idadeHoras > 24 || !item.chave || !item.filtro) return;

        const peso = idadeHoras <= 6 ? 1 : (idadeHoras <= 12 ? 0.6 : 0.25);
        const score = ((this.toNumber(item.total_registros) * 100000) + this.toNumber(item.rangeAbs)) * peso;
        if (!porChave[item.chave] || score > porChave[item.chave].score) {
          const filtro = item.filtro;
          filtro.origem_fallback_historico = '6h_12h_24h';
          filtro.score_fallback_historico = score;
          porChave[item.chave] = { score: score, filtro: filtro };
        }
      });

      return Object.keys(porChave)
        .map((chave: string): any => porChave[chave].filtro)
        .filter((filtro: any): boolean => this.filtroTopEhMultirraridadeValido(filtro) && this.filtroMultiDentroTetoCaixa(filtro))
        .sort((a: any, b: any): number => this.toNumber(b.score_fallback_historico) - this.toNumber(a.score_fallback_historico))
        .slice(0, 2);
    }

    private compactarFiltroMultiHistoricoFallback(filtro: any): any {
      filtro = filtro || {};
      return {
        id_filtro: filtro.id_filtro,
        total_registros: this.toNumber(filtro.total_registros),
        rangeAbs: this.toNumber(filtro.rangeAbs),
        menor_valor_observado: this.toNumber(filtro.menor_valor_observado || filtro.menor_valor || filtro.min),
        min: this.toNumber(filtro.min || filtro.menor_valor),
        max: this.toNumber(filtro.max || filtro.maior_valor),
        avg: filtro.avg,
        dados: filtro.dados || filtro.data || null,
        total_jogadores_distintos: this.toNumber(filtro.total_jogadores_distintos),
        resource_ids: filtro.resource_ids || null
      };
    }

    private filtroMultiDentroTetoCaixa(filtro: any): boolean {
      const menorValor = this.toNumber(filtro && (filtro.menor_valor_observado || filtro.menor_valor || filtro.min));
      return menorValor > 0 && menorValor <= this.configuracoes.piloto.principal.valor_caixa_maximo;
    }

    private getChaveTopFiltro(filtro: any): string {
      return filtro && filtro.id_filtro ? String(filtro.id_filtro) : '';
    }

    private getHistoricoFrequenciaTopFiltro(filtro: any): any {
      const chave = this.getChaveTopFiltro(filtro);
      const historico = this.getHistoricoCandidatosMultiStorage();
      const ciclos = ($.isArray(historico) ? historico : [])
        .filter((item: any): boolean => item && item.chave === chave)
        .map((item: any): any => ({
          horario: this.toNumber(item.horario),
          total: this.toNumber(item.total_registros),
          quantidade_mais: this.toNumber(item.total_registros),
          total_jogadores_distintos: this.toNumber(item.total_jogadores_distintos),
          resource_ids: item.resource_ids || null
        }))
        .slice(-3);
      const positivos = ciclos.filter((ciclo: any): boolean => this.toNumber(ciclo.quantidade_mais) > 0);
      const soma = ciclos.reduce((total: number, ciclo: any): number => total + this.toNumber(ciclo.quantidade_mais), 0);
      const totalJogadoresDistintos = this.toNumber(filtro && filtro.total_jogadores_distintos) || this.getTotalResourceIdsDistintos(filtro && filtro.resource_ids);
      const fluxoSustentado = positivos.length >= 3 && totalJogadoresDistintos >= 2;

      return {
        chave: chave,
        ultimos_ciclos: ciclos,
        positivos_ultimos_3: positivos.length,
        soma_ultimos_3: soma,
        total_jogadores_distintos: totalJogadoresDistintos,
        fluxo_forte_sustentado: fluxoSustentado,
        nivel_abertura_slot: this.getNivelAberturaSlot(ciclos),
        fluxo_confirmado_abrir_slot: fluxoSustentado && this.temFluxoConfirmadoAbrirSlot(ciclos),
        fluxo_muito_forte: this.toNumber(filtro && filtro.total_registros) >= 8
      };
    }

    private getTotalResourceIdsDistintos(resourceIds: any): number {
      if (!resourceIds || typeof resourceIds !== 'string') {
        return 0;
      }

      const mapa: any = {};
      resourceIds.split(',').forEach((item: string): void => {
        const id = this.toNumber(item.trim());
        if (id > 0) {
          mapa[id] = true;
        }
      });

      return Object.keys(mapa).length;
    }

    private getSerializedArrayLength(serialized: string, field: string): number {
      const match = new RegExp('s:\\d+:"' + field + '";a:(\\d+):\\{').exec(serialized);
      return match ? Number(match[1]) : -1;
    }

    private serializedFieldIsNull(serialized: string, field: string): boolean {
      return new RegExp('s:\\d+:"' + field + '";N;').test(serialized);
    }

    private serializedFieldExists(serialized: string, field: string): boolean {
      return new RegExp('s:\\d+:"' + field + '";').test(serialized);
    }

    private getMelhoresFiltrosDeMomento(
      topFiltros: IObjetoTopFiltros[],
      topX = 3,
      opts: any = {}
    ) {
      const options = {
        excludeSuspiciousIds: true,
        suspiciousIds: new Set<number>([]), // ex: new Set([4294967295])

        minRegistros: 3,
        minPriceFloor: 10000,     // min >= 10k
        minRangeAbs: 15000,       // (max - min) >= 15k
        maxPriceCeiling: null,

        useRobustPercentiles: true,
        exigirMultirraridade: false,

        ...opts
      };

      const toNum = (v: any) => {
        const n = typeof v === "string" ? Number(v) : v;
        return Number.isFinite(n) ? n : NaN;
      };

      const parseList = (s: any) => {
        if (!s || typeof s !== "string") return [];
        return s
          .split(",")
          .map((x: string) => Number(x.trim()))
          .filter((n: number) => Number.isFinite(n));
      };

      const percentile = (sortedAsc: number[], p: number) => {
        if (!sortedAsc.length) return NaN;
        const idx = Math.floor((sortedAsc.length - 1) * p);
        return sortedAsc[idx];
      };

      const picked = (topFiltros || [])
        .map((f: any) => {
          const id_filtro = toNum(f.id_filtro);
          const total = toNum(f.total_registros);

          if (!Number.isFinite(id_filtro)) return null;
          if (!Number.isFinite(total) || total < options.minRegistros) return null;

          if (options.exigirMultirraridade && !this.filtroTopEhMultirraridadeValido(f)) {
            return null;
          }

          if (options.excludeSuspiciousIds && options.suspiciousIds.has(id_filtro)) {
            return null;
          }

          let min = toNum(f.menor_valor);
          const menorValorObservado = min;
          let max = toNum(f.maior_valor);

          // robustez: usa p10/p90 se tiver lista de valores suficiente
          if (options.useRobustPercentiles) {
            const valoresArr = parseList(f.valores);
            if (valoresArr.length >= 5) {
              const sorted = [...valoresArr].sort((a, b) => a - b);
              const p10 = percentile(sorted, 0.10);
              const p90 = percentile(sorted, 0.90);
              if (Number.isFinite(p10)) min = p10;
              if (Number.isFinite(p90)) max = p90;
            }
          }

          if (!Number.isFinite(min) || !Number.isFinite(max) || min <= 0 || max <= 0 || max < min) return null;

          if (min < options.minPriceFloor) return null;
          if (options.maxPriceCeiling !== null && Number.isFinite(options.maxPriceCeiling) && (!Number.isFinite(menorValorObservado) || menorValorObservado > options.maxPriceCeiling)) return null;

          const rangeAbs = max - min;
          if (rangeAbs < options.minRangeAbs) return null;

          return {
            ...f,
            id_filtro,
            total_registros: total,
            min,
            max,
            menor_valor_observado: menorValorObservado,
            avg: toNum(f.valor_medio),
            rangeAbs
          };
        })
        .filter(Boolean)
        // maior ocorrência primeiro; desempate: maior range; depois maior max
        .sort((a: any, b: any) =>
          (b.total_registros - a.total_registros) ||
          (b.rangeAbs - a.rangeAbs) ||
          (b.max - a.max)
        );

      return picked.slice(0, topX);
    }

  }
}
